// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { AllowsInterestPolicyListData, AllowsInterestPolicyListErrors, AllowsInterestPolicyListResponses, AndroidCallbackData, AndroidCallbackErrors, AndroidCallbackResponses, BestContentsFeedbackData, BestContentsFeedbackErrors, BestContentsFeedbackResponses, CalculateDonationData, CalculateDonationErrors, CalculateDonationResponses, CallbackCompleteData, CallbackCompleteErrors, CallbackCompleteResponses, CertificationCheckData, CertificationCheckErrors, CertificationCheckResponses, CheckPlusSuccessData, CheckPlusSuccessErrors, CheckPlusSuccessResponses, CommonCodeInit1Data, CommonCodeInit1Errors, CommonCodeInit1Responses, CommonCodeInitData, CommonCodeInitErrors, CommonCodeInitResponses, CreateApiCounselData, CreateApiCounselErrors, CreateApiCounselResponses, DetailWelloLandingData, DetailWelloLandingErrors, DetailWelloLandingResponses, ExpositionLinkUrlListData, ExpositionLinkUrlListErrors, ExpositionLinkUrlListResponses, FaqListData, FaqListErrors, FaqListResponses, FeedbackCommunityWelloNewsData, FeedbackCommunityWelloNewsErrors, FeedbackCommunityWelloNewsResponses, FeedbackPointMarketProductData, FeedbackPointMarketProductErrors, FeedbackPointMarketProductResponses, FileDecryptionDownloadData, FileDecryptionDownloadErrors, FileDecryptionDownloadResponses, FileDeleteData, FileDeleteErrors, FileDeleteResponses, FileUploadData, FileUploadErrors, FileUploadResponses, FindAllInquiriesData, FindAllInquiriesErrors, FindAllInquiriesResponses, FindArticleData, FindArticleErrors, FindArticleFeedbackData, FindArticleFeedbackErrors, FindArticleFeedbackResponses, FindArticleResponses, FindBestContentsData, FindBestContentsErrors, FindBestContentsResponses, FindDonationBusinessesData, FindDonationBusinessesErrors, FindDonationBusinessesResponses, FindFeedsData, FindFeedsErrors, FindFeedsResponses, FindGeneralDownloadableCouponsData, FindGeneralDownloadableCouponsErrors, FindGeneralDownloadableCouponsResponses, FindGiftProductsData, FindGiftProductsErrors, FindGiftProductsResponses, FindGoodPointTypesData, FindGoodPointTypesErrors, FindGoodPointTypesResponses, FindHometownNewsData, FindHometownNewsErrors, FindHometownNewsResponses, FindInquiryData, FindInquiryErrors, FindInquiryResponses, FindLocalMarketProductsData, FindLocalMarketProductsErrors, FindLocalMarketProductsResponses, FindMonthlyThemesData, FindMonthlyThemesErrors, FindMonthlyThemesResponses, FindPhotoReviewsData, FindPhotoReviewsErrors, FindPhotoReviewsResponses, FindPoliciesData, FindPoliciesErrors, FindPoliciesResponses, FindQueryAgeCodeData, FindQueryAgeCodeErrors, FindQueryAgeCodeResponses, FindQueryJobCodeData, FindQueryJobCodeErrors, FindQueryJobCodeResponses, FindQueryProvisionCodeData, FindQueryProvisionCodeErrors, FindQueryProvisionCodeResponses, FindQueryTargetCodeData, FindQueryTargetCodeErrors, FindQueryTargetCodeResponses, FindReviewData, FindReviewErrors, FindReviewResponses, FindReviewsData, FindReviewsErrors, FindReviewsResponses, FindThemeArticlesData, FindThemeArticlesErrors, FindThemeArticlesResponses, FindThemeFestivalsData, FindThemeFestivalsErrors, FindThemeFestivalsResponses, FindTourDistanceData, FindTourDistanceErrors, FindTourDistanceResponses, FindTourFeedbackData, FindTourFeedbackErrors, FindTourFeedbackResponses, FindTourFestivalData, FindTourFestivalErrors, FindTourFestivalResponses, FindTourFestivalsData, FindTourFestivalsErrors, FindTourFestivalsResponses, FindTourLclsSystmCodeListData, FindTourLclsSystmCodeListErrors, FindTourLclsSystmCodeListResponses, FindTourReviewsData, FindTourReviewsErrors, FindTourReviewsResponses, GeolocationData, GeolocationErrors, GeolocationResponses, GetActiveMaintenanceListData, GetActiveMaintenanceListErrors, GetActiveMaintenanceListResponses, GetAdminHomeSearchKeywordListData, GetAdminHomeSearchKeywordListErrors, GetAdminHomeSearchKeywordListResponses, GetApiPolicyListData, GetApiPolicyListErrors, GetApiPolicyListResponses, GetApiPolicyNameListData, GetApiPolicyNameListErrors, GetApiPolicyNameListResponses, GetApiProductNameListData, GetApiProductNameListErrors, GetApiProductNameListResponses, GetApiThemeData, GetApiThemeErrors, GetApiThemeKeywordNameListData, GetApiThemeKeywordNameListErrors, GetApiThemeKeywordNameListResponses, GetApiThemeListData, GetApiThemeListErrors, GetApiThemeListResponses, GetApiThemeNameListData, GetApiThemeNameListErrors, GetApiThemeNameListResponses, GetApiThemeResponses, GetBestContentsData, GetBestContentsErrors, GetBestContentsResponses, GetCommunityWelloNewsData, GetCommunityWelloNewsErrors, GetCommunityWelloNewsListData, GetCommunityWelloNewsListErrors, GetCommunityWelloNewsListResponses, GetCommunityWelloNewsResponses, GetControlManagementsData, GetControlManagementsErrors, GetControlManagementsResponses, GetDecemberEventGiftProductListData, GetDecemberEventGiftProductListErrors, GetDecemberEventGiftProductListResponses, GetDecemberInstitutionEventInfoListData, GetDecemberInstitutionEventInfoListErrors, GetDecemberInstitutionEventInfoListResponses, GetDecemberRandomTicketWinnerListData, GetDecemberRandomTicketWinnerListErrors, GetDecemberRandomTicketWinnerListResponses, GetDonationBusinessCommentListData, GetDonationBusinessCommentListErrors, GetDonationBusinessCommentListResponses, GetDonationBusinessData, GetDonationBusinessDetailCountData, GetDonationBusinessDetailCountErrors, GetDonationBusinessDetailCountResponses, GetDonationBusinessErrors, GetDonationBusinessListData, GetDonationBusinessListErrors, GetDonationBusinessListResponses, GetDonationBusinessResponses, GetEmergencyRoomCodeListData, GetEmergencyRoomCodeListErrors, GetEmergencyRoomCodeListResponses, GetEmergencyRoomData, GetEmergencyRoomErrors, GetEmergencyRoomListCountData, GetEmergencyRoomListCountErrors, GetEmergencyRoomListCountResponses, GetEmergencyRoomListData, GetEmergencyRoomListErrors, GetEmergencyRoomListResponses, GetEmergencyRoomLiveData, GetEmergencyRoomLiveErrors, GetEmergencyRoomLiveResponses, GetEmergencyRoomRegionListData, GetEmergencyRoomRegionListErrors, GetEmergencyRoomRegionListResponses, GetEmergencyRoomResponses, GetEventAmountInfoData, GetEventAmountInfoErrors, GetEventAmountInfoResponses, GetGiftOrderProductPhotoReviewListByProductData, GetGiftOrderProductPhotoReviewListByProductErrors, GetGiftOrderProductPhotoReviewListByProductResponses, GetGiftOrderProductReviewData, GetGiftOrderProductReviewErrors, GetGiftOrderProductReviewListData, GetGiftOrderProductReviewListErrors, GetGiftOrderProductReviewListResponses, GetGiftOrderProductReviewResponses, GetGiftProductBlockListData, GetGiftProductBlockListErrors, GetGiftProductBlockListResponses, GetGiftProductData, GetGiftProductErrors, GetGiftProductList1Data, GetGiftProductList1Errors, GetGiftProductList1Responses, GetGiftProductListByInstitutionData, GetGiftProductListByInstitutionErrors, GetGiftProductListByInstitutionResponses, GetGiftProductListData, GetGiftProductListErrors, GetGiftProductListResponses, GetGiftProductPopularByInstitutionListData, GetGiftProductPopularByInstitutionListErrors, GetGiftProductPopularByInstitutionListResponses, GetGiftProductResponses, GetGiftProductSeoData, GetGiftProductSeoErrors, GetGiftProductSeoResponses, GetGiftReviewFeedData, GetGiftReviewFeedErrors, GetGiftReviewFeedResponses, GetHomeDonationEventData, GetHomeDonationEventErrors, GetHomeDonationEventResponses, GetHomeDonationHistoryByDonationBusinessListData, GetHomeDonationHistoryByDonationBusinessListErrors, GetHomeDonationHistoryByDonationBusinessListResponses, GetHomeDonationStatisticsListData, GetHomeDonationStatisticsListErrors, GetHomeDonationStatisticsListResponses, GetHomeInquiryData, GetHomeInquiryErrors, GetHomeInquiryListData, GetHomeInquiryListErrors, GetHomeInquiryListResponses, GetHomeInquiryResponses, GetHomeInstitutionBenefitListAllData, GetHomeInstitutionBenefitListAllErrors, GetHomeInstitutionBenefitListAllResponses, GetHomeInstitutionBenefitListData, GetHomeInstitutionBenefitListErrors, GetHomeInstitutionBenefitListResponses, GetHomeInstitutionBenefitPrivateListData, GetHomeInstitutionBenefitPrivateListErrors, GetHomeInstitutionBenefitPrivateListResponses, GetHomeInstitutionBenefitPublicListData, GetHomeInstitutionBenefitPublicListErrors, GetHomeInstitutionBenefitPublicListResponses, GetHomeInstitutionBenefitRegionListData, GetHomeInstitutionBenefitRegionListErrors, GetHomeInstitutionBenefitRegionListResponses, GetHomeInstitutionContentData, GetHomeInstitutionContentErrors, GetHomeInstitutionContentListData, GetHomeInstitutionContentListErrors, GetHomeInstitutionContentListResponses, GetHomeInstitutionContentResponses, GetHomeInstitutionData, GetHomeInstitutionDonationBusinessData, GetHomeInstitutionDonationBusinessErrors, GetHomeInstitutionDonationBusinessResponses, GetHomeInstitutionErrors, GetHomeInstitutionEventData, GetHomeInstitutionEventErrors, GetHomeInstitutionEventListData, GetHomeInstitutionEventListErrors, GetHomeInstitutionEventListResponses, GetHomeInstitutionEventResponses, GetHomeInstitutionListForSearchFilterData, GetHomeInstitutionListForSearchFilterErrors, GetHomeInstitutionListForSearchFilterResponses, GetHomeInstitutionPolicyListData, GetHomeInstitutionPolicyListErrors, GetHomeInstitutionPolicyListResponses, GetHomeInstitutionResponses, GetHomeInstitutionWithGiftProductListData, GetHomeInstitutionWithGiftProductListErrors, GetHomeInstitutionWithGiftProductListResponses, GetHomeLoveGovCodeToIdData, GetHomeLoveGovCodeToIdErrors, GetHomeLoveGovCodeToIdResponses, GetHomeLoveMainDailyPickListData, GetHomeLoveMainDailyPickListErrors, GetHomeLoveMainDailyPickListResponses, GetHomeLoveMainFeaturedDonationBusinessesListData, GetHomeLoveMainFeaturedDonationBusinessesListErrors, GetHomeLoveMainFeaturedDonationBusinessesListResponses, GetHomeLoveMainInstitutionSpecialtyListData, GetHomeLoveMainInstitutionSpecialtyListErrors, GetHomeLoveMainInstitutionSpecialtyListResponses, GetHomeLoveMainRecommendedInstitutionListData, GetHomeLoveMainRecommendedInstitutionListErrors, GetHomeLoveMainRecommendedInstitutionListResponses, GetHomeNoticeData, GetHomeNoticeErrors, GetHomeNoticeListData, GetHomeNoticeListErrors, GetHomeNoticeListResponses, GetHomeNoticeResponses, GetHomePopupNoticeData, GetHomePopupNoticeErrors, GetHomePopupNoticeResponses, GetHomeWelloPolicyApplyListData, GetHomeWelloPolicyApplyListErrors, GetHomeWelloPolicyApplyListResponses, GetInstitutionGiftProductListData, GetInstitutionGiftProductListErrors, GetInstitutionGiftProductListResponses, GetInstitutionRelatedDonationBusinessData, GetInstitutionRelatedDonationBusinessErrors, GetInstitutionRelatedDonationBusinessResponses, GetInstitutionSpecialtyListData, GetInstitutionSpecialtyListErrors, GetInstitutionSpecialtyListResponses, GetKbMemberLoginTypeListData, GetKbMemberLoginTypeListErrors, GetKbMemberLoginTypeListResponses, GetListPolicyCaseCategoryData, GetListPolicyCaseCategoryErrors, GetListPolicyCaseCategoryResponses, GetLiveWelloCommentListData, GetLiveWelloCommentListErrors, GetLiveWelloCommentListResponses, GetMaintenanceData, GetMaintenanceErrors, GetMaintenanceResponses, GetMedianIncomeListData, GetMedianIncomeListErrors, GetMedianIncomeListResponses, GetMemberNameByInviteCodeData, GetMemberNameByInviteCodeErrors, GetMemberNameByInviteCodeResponses, GetMetaPolicyCommentList1Data, GetMetaPolicyCommentList1Errors, GetMetaPolicyCommentList1Responses, GetMetaPolicyCommentListData, GetMetaPolicyCommentListErrors, GetMetaPolicyCommentListResponses, GetNCloudGeocodingByCodeData, GetNCloudGeocodingByCodeErrors, GetNCloudGeocodingByCodeResponses, GetNonMemberSuggestPolicyListData, GetNonMemberSuggestPolicyListErrors, GetNonMemberSuggestPolicyListResponses, GetOrderedHomeInstitutionEventListData, GetOrderedHomeInstitutionEventListErrors, GetOrderedHomeInstitutionEventListResponses, GetPointBudgetData, GetPointBudgetErrors, GetPointBudgetResponses, GetPointEarningData, GetPointEarningErrors, GetPointEarningResponses, GetPointInfoData, GetPointInfoErrors, GetPointInfoResponses, GetPointMarketBrandListData, GetPointMarketBrandListErrors, GetPointMarketBrandListResponses, GetPointMarketProductData, GetPointMarketProductErrors, GetPointMarketProductListByBrandData, GetPointMarketProductListByBrandErrors, GetPointMarketProductListByBrandResponses, GetPointMarketProductListData, GetPointMarketProductListErrors, GetPointMarketProductListResponses, GetPointMarketProductResponses, GetPolicyCodeGeocodingListData, GetPolicyCodeGeocodingListErrors, GetPolicyCodeGeocodingListResponses, GetPolicyDictionaryListData, GetPolicyDictionaryListErrors, GetPolicyDictionaryListResponses, GetPopularPointMarketProductListData, GetPopularPointMarketProductListErrors, GetPopularPointMarketProductListResponses, GetPrimaryGiftCategoryListData, GetPrimaryGiftCategoryListErrors, GetPrimaryGiftCategoryListResponses, GetProductDetailByProductNumberData, GetProductDetailByProductNumberErrors, GetProductDetailByProductNumberResponses, GetProductDetailData, GetProductDetailErrors, GetProductDetailResponses, GetProductFeedListData, GetProductFeedListErrors, GetProductFeedListResponses, GetProductSeoByProductIdData, GetProductSeoByProductIdErrors, GetProductSeoByProductIdResponses, GetProductSeoData, GetProductSeoErrors, GetProductSeoResponses, GetRecentDonatedGiftItemsData, GetRecentDonatedGiftItemsErrors, GetRecentDonatedGiftItemsResponses, GetRecentEventHistoryListData, GetRecentEventHistoryListErrors, GetRecentEventHistoryListInSeptemberData, GetRecentEventHistoryListInSeptemberErrors, GetRecentEventHistoryListInSeptemberResponses, GetRecentEventHistoryListResponses, GetRecentOpenedGiftBoxListData, GetRecentOpenedGiftBoxListErrors, GetRecentOpenedGiftBoxListResponses, GetRelatedDonationBusinessData, GetRelatedDonationBusinessErrors, GetRelatedDonationBusinessResponses, GetRelatedGiftProductListData, GetRelatedGiftProductListErrors, GetRelatedGiftProductListResponses, GetRelatedHometownNewsListData, GetRelatedHometownNewsListErrors, GetRelatedHometownNewsListResponses, GetSituationPolicyListData, GetSituationPolicyListErrors, GetSituationPolicyListResponses, GetTopDonationEventHistoryListData, GetTopDonationEventHistoryListErrors, GetTopDonationEventHistoryListResponses, GetTopInviterListInAugustData, GetTopInviterListInAugustErrors, GetTopInviterListInAugustResponses, GetUrlMappingData, GetUrlMappingErrors, GetUrlMappingResponses, GetWeeklyBestGiftPhotoReviewsData, GetWeeklyBestGiftPhotoReviewsErrors, GetWeeklyBestGiftPhotoReviewsResponses, GetWelcomeMonitorDisplayListData, GetWelcomeMonitorDisplayListErrors, GetWelcomeMonitorDisplayListResponses, GetWelloPickBannerListData, GetWelloPickBannerListErrors, GetWelloPickBannerListResponses, GetWelloQuickMenuListData, GetWelloQuickMenuListErrors, GetWelloQuickMenuListResponses, HandleAuthResultData, HandleAuthResultErrors, HandleAuthResultResponses, HandleNicePayWebhookData, HandleNicePayWebhookErrors, HandleNicePayWebhookResponses, HometownNewsData, HometownNewsErrors, HometownNewsFeedbackData, HometownNewsFeedbackErrors, HometownNewsFeedbackResponses, HometownNewsResponses, IosCallbackData, IosCallbackErrors, IosCallbackResponses, IsEventInProgressData, IsEventInProgressErrors, IsEventInProgressResponses, JoinEventData, JoinEventErrors, JoinEventResponses, KbWelloPolicyCodeAllListData, KbWelloPolicyCodeAllListErrors, KbWelloPolicyCodeAllListResponses, LoginWelloSnsMemberData, LoginWelloSnsMemberErrors, LoginWelloSnsMemberResponses, LoginWelloWithKbPayData, LoginWelloWithKbPayErrors, LoginWelloWithKbPayResponses, MessageReceiveData, MessageReceiveErrors, MessageReceiveResponses, MetaCodeAllData, MetaCodeAllErrors, MetaCodeAllResponses, MetaPolicyData, MetaPolicyErrors, MetaPolicyFeedbackData, MetaPolicyFeedbackErrors, MetaPolicyFeedbackResponses, MetaPolicyResponses, NewWelloAppPushCntData, NewWelloAppPushCntErrors, NewWelloAppPushCntResponses, NoticeData, NoticeErrors, NoticeList1Data, NoticeList1Errors, NoticeList1Responses, NoticeListData, NoticeListErrors, NoticeListResponses, NoticeResponses, PopularPolicyListData, PopularPolicyListErrors, PopularPolicyListResponses, RejectMessageData, RejectMessageErrors, RejectMessageResponses, ResignMemberData, ResignMemberErrors, ResignMemberResponses, ResignWelloWithKbPayData, ResignWelloWithKbPayErrors, ResignWelloWithKbPayResponses, ReverseGeocodingData, ReverseGeocodingErrors, ReverseGeocodingResponses, SaveAllowsWelloDeviceInfoData, SaveAllowsWelloDeviceInfoErrors, SaveAllowsWelloDeviceInfoResponses, SaveLoginResultData, SaveLoginResultErrors, SaveLoginResultResponses, SaveWelloNonmemberRegionData, SaveWelloNonmemberRegionErrors, SaveWelloNonmemberRegionResponses, SaveWelloTrackingData, SaveWelloTrackingErrors, SaveWelloTrackingResponses, SearchGiftProductListByContainsData, SearchGiftProductListByContainsErrors, SearchGiftProductListByContainsResponses, SearchGiftProductListCountData, SearchGiftProductListCountErrors, SearchGiftProductListCountResponses, SearchGiftProductListData, SearchGiftProductListErrors, SearchGiftProductListResponses, SendCertificationCellphoneData, SendCertificationCellphoneErrors, SendCertificationCellphoneResponses, SendExtAppPushData, SendExtAppPushErrors, SendExtAppPushResponses, SituationListData, SituationListErrors, SituationListResponses, SnsRefreshTokenData, SnsRefreshTokenErrors, SnsRefreshTokenResponses, TermData, TermErrors, TermHistoryData, TermHistoryErrors, TermHistoryResponses, TermResponses, UpdateFileTempSaveYnData, UpdateFileTempSaveYnErrors, UpdateFileTempSaveYnResponses, UpdateMessageReceiveData, UpdateMessageReceiveErrors, UpdateMessageReceiveResponses, UpdatePolicyAiInfoData, UpdatePolicyAiInfoErrors, UpdatePolicyAiInfoResponses, UpdateWelloAppPushRead1Data, UpdateWelloAppPushRead1Errors, UpdateWelloAppPushRead1Responses, UpdateWelloAppPushReadData, UpdateWelloAppPushReadErrors, UpdateWelloAppPushReadResponses, ViewHomeGiftProductData, ViewHomeGiftProductErrors, ViewHomeGiftProductResponses, WelloAppPushListData, WelloAppPushListErrors, WelloAppPushListResponses, WelloBeforeLoginData, WelloBeforeLoginErrors, WelloBeforeLoginResponses, WelloPickListData, WelloPickListErrors, WelloPickListResponses, WelloPickPolicyListData, WelloPickPolicyListErrors, WelloPickPolicyListResponses, WelloPolicyCodeAllListData, WelloPolicyCodeAllListErrors, WelloPolicyCodeAllListResponses, WelloPolicyCodeBabyListData, WelloPolicyCodeBabyListErrors, WelloPolicyCodeBabyListResponses, WelloPolicyCodeListData, WelloPolicyCodeListErrors, WelloPolicyCodeListResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * 알림수신여부 조회
 *
 * 알림수신 여부를 조회합니다
 */
export const messageReceive = <ThrowOnError extends boolean = false>(options: Options<MessageReceiveData, ThrowOnError>) => (options.client ?? client).get<MessageReceiveResponses, MessageReceiveErrors, ThrowOnError>({ url: '/wello/v2/allows/wello-device-info/message-receive', ...options });

/**
 * 알림수신여부 수정
 *
 * 알림수신 여부를 수정합니다
 */
export const updateMessageReceive = <ThrowOnError extends boolean = false>(options: Options<UpdateMessageReceiveData, ThrowOnError>) => (options.client ?? client).put<UpdateMessageReceiveResponses, UpdateMessageReceiveErrors, ThrowOnError>({
    url: '/wello/v2/allows/wello-device-info/message-receive',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 웰로 앱 푸시 목록 조회
 */
export const welloAppPushList = <ThrowOnError extends boolean = false>(options: Options<WelloAppPushListData, ThrowOnError>) => (options.client ?? client).get<WelloAppPushListResponses, WelloAppPushListErrors, ThrowOnError>({ url: '/wello/v2/allows/wello-app-push', ...options });

/**
 * 웰로 앱 푸시 읽음 처리
 */
export const updateWelloAppPushRead = <ThrowOnError extends boolean = false>(options: Options<UpdateWelloAppPushReadData, ThrowOnError>) => (options.client ?? client).put<UpdateWelloAppPushReadResponses, UpdateWelloAppPushReadErrors, ThrowOnError>({
    url: '/wello/v2/allows/wello-app-push',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 파일 삭제
 */
export const fileDelete = <ThrowOnError extends boolean = false>(options: Options<FileDeleteData, ThrowOnError>) => (options.client ?? client).delete<FileDeleteResponses, FileDeleteErrors, ThrowOnError>({
    url: '/wello/v2/allows/s3',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 파일 업로드
 */
export const fileUpload = <ThrowOnError extends boolean = false>(options?: Options<FileUploadData, ThrowOnError>) => (options?.client ?? client).post<FileUploadResponses, FileUploadErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/wello/v2/allows/s3',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * 파일 템프 저장 여부 상태 수정
 */
export const updateFileTempSaveYn = <ThrowOnError extends boolean = false>(options: Options<UpdateFileTempSaveYnData, ThrowOnError>) => (options.client ?? client).put<UpdateFileTempSaveYnResponses, UpdateFileTempSaveYnErrors, ThrowOnError>({
    url: '/wello/v2/allows/s3',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 정책 AI 정보 업데이트
 */
export const updatePolicyAiInfo = <ThrowOnError extends boolean = false>(options: Options<UpdatePolicyAiInfoData, ThrowOnError>) => (options.client ?? client).put<UpdatePolicyAiInfoResponses, UpdatePolicyAiInfoErrors, ThrowOnError>({
    url: '/wello/v2/allows/policy/{metaPolicyIdIdx}/ai',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const rejectMessage = <ThrowOnError extends boolean = false>(options: Options<RejectMessageData, ThrowOnError>) => (options.client ?? client).put<RejectMessageResponses, RejectMessageErrors, ThrowOnError>({
    url: '/wello/v2/allows/message-reject/member-wello',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 웰로 비회원 트래킹 정보 저장
 */
export const saveWelloTracking = <ThrowOnError extends boolean = false>(options: Options<SaveWelloTrackingData, ThrowOnError>) => (options.client ?? client).post<SaveWelloTrackingResponses, SaveWelloTrackingErrors, ThrowOnError>({
    url: '/wello/v2/allows/wello-track',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 비회원 대상지역 정보 저장
 */
export const saveWelloNonmemberRegion = <ThrowOnError extends boolean = false>(options: Options<SaveWelloNonmemberRegionData, ThrowOnError>) => (options.client ?? client).post<SaveWelloNonmemberRegionResponses, SaveWelloNonmemberRegionErrors, ThrowOnError>({
    url: '/wello/v2/allows/wello-nonmember-region',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 웰로 디바이스 정보 저장
 */
export const saveAllowsWelloDeviceInfo = <ThrowOnError extends boolean = false>(options: Options<SaveAllowsWelloDeviceInfoData, ThrowOnError>) => (options.client ?? client).post<SaveAllowsWelloDeviceInfoResponses, SaveAllowsWelloDeviceInfoErrors, ThrowOnError>({
    url: '/wello/v2/allows/wello-device-info',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 웰로 앱 푸시 트래킹&읽음 처리
 */
export const updateWelloAppPushRead1 = <ThrowOnError extends boolean = false>(options: Options<UpdateWelloAppPushRead1Data, ThrowOnError>) => (options.client ?? client).post<UpdateWelloAppPushRead1Responses, UpdateWelloAppPushRead1Errors, ThrowOnError>({ url: '/wello/v2/allows/wello-app-push/{welloAppPushReceiverId}', ...options });

/**
 * 웰로 앱 푸시(외부) 요청
 */
export const sendExtAppPush = <ThrowOnError extends boolean = false>(options: Options<SendExtAppPushData, ThrowOnError>) => (options.client ?? client).post<SendExtAppPushResponses, SendExtAppPushErrors, ThrowOnError>({
    url: '/wello/v2/allows/wello-app-push/ext',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 상품 상세 조회 피드백(조회수 증가)
 */
export const feedbackPointMarketProduct = <ThrowOnError extends boolean = false>(options: Options<FeedbackPointMarketProductData, ThrowOnError>) => (options.client ?? client).post<FeedbackPointMarketProductResponses, FeedbackPointMarketProductErrors, ThrowOnError>({ url: '/wello/v2/allows/point-market/product/{productIdIdx}/feedback', ...options });

/**
 * 공통코드 초기화
 *
 * 공통코드가 추가된 경우 초기화 합니다
 */
export const commonCodeInit = <ThrowOnError extends boolean = false>(options: Options<CommonCodeInitData, ThrowOnError>) => (options.client ?? client).post<CommonCodeInitResponses, CommonCodeInitErrors, ThrowOnError>({ url: '/wello/v2/allows/meta-code/reset', ...options });

export const loginWelloSnsMember = <ThrowOnError extends boolean = false>(options: Options<LoginWelloSnsMemberData, ThrowOnError>) => (options.client ?? client).post<LoginWelloSnsMemberResponses, LoginWelloSnsMemberErrors, ThrowOnError>({
    url: '/wello/v2/allows/member-oauth/sns/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const welloBeforeLogin = <ThrowOnError extends boolean = false>(options: Options<WelloBeforeLoginData, ThrowOnError>) => (options.client ?? client).post<WelloBeforeLoginResponses, WelloBeforeLoginErrors, ThrowOnError>({
    url: '/wello/v2/allows/member-oauth/before/sns/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 앱 로그인 요청결과 저장
 */
export const saveLoginResult = <ThrowOnError extends boolean = false>(options: Options<SaveLoginResultData, ThrowOnError>) => (options.client ?? client).post<SaveLoginResultResponses, SaveLoginResultErrors, ThrowOnError>({
    url: '/wello/v2/allows/log-app-login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * NicePay 인증 결과 수신 (returnUrl)
 *
 * NicePay 인증 결과 수신 및 결제 승인 처리.
 *
 * <p>Content-Type: application/x-www-form-urlencoded
 * NicePay가 POST로 전송하는 파라미터를 @RequestParam으로 수신한다.
 * 처리 후 프론트엔드 성공/실패 페이지로 302 redirect한다.</p>
 */
export const handleAuthResult = <ThrowOnError extends boolean = false>(options: Options<HandleAuthResultData, ThrowOnError>) => (options.client ?? client).post<HandleAuthResultResponses, HandleAuthResultErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/payments/auth-result', ...options });

/**
 * 이벤트 참여 요청
 */
export const joinEvent = <ThrowOnError extends boolean = false>(options: Options<JoinEventData, ThrowOnError>) => (options.client ?? client).post<JoinEventResponses, JoinEventErrors, ThrowOnError>({
    url: '/wello/v2/allows/kb',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * KB PAY 회원 웰로 로그인
 *
 * DomainRestrictionFilter에서 api 사용중으로 url 변경시 함께 변경 되어야 합니다.
 */
export const loginWelloWithKbPay = <ThrowOnError extends boolean = false>(options: Options<LoginWelloWithKbPayData, ThrowOnError>) => (options.client ?? client).post<LoginWelloWithKbPayResponses, LoginWelloWithKbPayErrors, ThrowOnError>({
    url: '/wello/v2/allows/kb-pay/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 특정 답례품 목록
 */
export const getGiftProductList = <ThrowOnError extends boolean = false>(options: Options<GetGiftProductListData, ThrowOnError>) => (options.client ?? client).post<GetGiftProductListResponses, GetGiftProductListErrors, ThrowOnError>({
    url: '/wello/v2/allows/home/gift-product/products',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 고향사랑 컨텐츠 조회수 증가
 */
export const viewHomeGiftProduct = <ThrowOnError extends boolean = false>(options: Options<ViewHomeGiftProductData, ThrowOnError>) => (options.client ?? client).post<ViewHomeGiftProductResponses, ViewHomeGiftProductErrors, ThrowOnError>({
    url: '/wello/v2/allows/home-love-view',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 피드 목록 조회
 *
 * 6개 소스의 컨텐츠를 혼합하여 피드 목록을 조회합니다
 */
export const findFeeds = <ThrowOnError extends boolean = false>(options: Options<FindFeedsData, ThrowOnError>) => (options.client ?? client).post<FindFeedsResponses, FindFeedsErrors, ThrowOnError>({
    url: '/wello/v2/allows/feed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * NICE Pay 웹훅 수신
 *
 * NICE Pay 웹훅을 처리합니다.
 */
export const handleNicePayWebhook = <ThrowOnError extends boolean = false>(options: Options<HandleNicePayWebhookData, ThrowOnError>) => (options.client ?? client).post<HandleNicePayWebhookResponses, HandleNicePayWebhookErrors, ThrowOnError>({
    url: '/wello/v2/allows/external/local-market/payments/webhook',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 인증 번호 확인
 *
 * 인증 번호 확인
 */
export const certificationCheck = <ThrowOnError extends boolean = false>(options: Options<CertificationCheckData, ThrowOnError>) => (options.client ?? client).post<CertificationCheckResponses, CertificationCheckErrors, ThrowOnError>({
    url: '/wello/v2/allows/certification/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 휴대전화번호 인증 발송
 *
 * 휴대전화번호 인증 발송
 */
export const sendCertificationCellphone = <ThrowOnError extends boolean = false>(options: Options<SendCertificationCellphoneData, ThrowOnError>) => (options.client ?? client).post<SendCertificationCellphoneResponses, SendCertificationCellphoneErrors, ThrowOnError>({
    url: '/wello/v2/allows/certification/cellphone',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 블록리스트 초기화
 *
 * 블록리스트 추가된 경우 초기화 합니다
 */
export const commonCodeInit1 = <ThrowOnError extends boolean = false>(options: Options<CommonCodeInit1Data, ThrowOnError>) => (options.client ?? client).post<CommonCodeInit1Responses, CommonCodeInit1Errors, ThrowOnError>({ url: '/wello/v2/allows/blocklist/reset', ...options });

/**
 * API 도입 문의 작성
 */
export const createApiCounsel = <ThrowOnError extends boolean = false>(options: Options<CreateApiCounselData, ThrowOnError>) => (options.client ?? client).post<CreateApiCounselResponses, CreateApiCounselErrors, ThrowOnError>({
    url: '/wello/v2/allows/api-counsel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 웰로 퀵 메뉴 목록 조회
 *
 * 웰로 메인 상단 퀵 메뉴 목록을 조회합니다
 */
export const getWelloQuickMenuList = <ThrowOnError extends boolean = false>(options?: Options<GetWelloQuickMenuListData, ThrowOnError>) => (options?.client ?? client).get<GetWelloQuickMenuListResponses, GetWelloQuickMenuListErrors, ThrowOnError>({ url: '/wello/v2/allows/wello-quick-menu', ...options });

/**
 * 웰로 정책 코드 목록
 */
export const welloPolicyCodeList = <ThrowOnError extends boolean = false>(options: Options<WelloPolicyCodeListData, ThrowOnError>) => (options.client ?? client).get<WelloPolicyCodeListResponses, WelloPolicyCodeListErrors, ThrowOnError>({ url: '/wello/v2/allows/wello-policy-code', ...options });

/**
 * 경도&위도로 현재 위치의 지역정보 조회
 */
export const reverseGeocoding = <ThrowOnError extends boolean = false>(options: Options<ReverseGeocodingData, ThrowOnError>) => (options.client ?? client).get<ReverseGeocodingResponses, ReverseGeocodingErrors, ThrowOnError>({ url: '/wello/v2/allows/wello-policy-code/reverse-geocoding', ...options });

/**
 * KB 정책 코드 목록
 */
export const kbWelloPolicyCodeAllList = <ThrowOnError extends boolean = false>(options?: Options<KbWelloPolicyCodeAllListData, ThrowOnError>) => (options?.client ?? client).get<KbWelloPolicyCodeAllListResponses, KbWelloPolicyCodeAllListErrors, ThrowOnError>({ url: '/wello/v2/allows/wello-policy-code/kb', ...options });

/**
 * IP로 현재 위치의 지역정보 조회
 */
export const geolocation = <ThrowOnError extends boolean = false>(options: Options<GeolocationData, ThrowOnError>) => (options.client ?? client).get<GeolocationResponses, GeolocationErrors, ThrowOnError>({ url: '/wello/v2/allows/wello-policy-code/geolocation', ...options });

/**
 * 웰로 정책 코드 육아생활 목록
 */
export const welloPolicyCodeBabyList = <ThrowOnError extends boolean = false>(options?: Options<WelloPolicyCodeBabyListData, ThrowOnError>) => (options?.client ?? client).get<WelloPolicyCodeBabyListResponses, WelloPolicyCodeBabyListErrors, ThrowOnError>({ url: '/wello/v2/allows/wello-policy-code/baby', ...options });

/**
 * 웰로 정책 코드 전체 목록
 */
export const welloPolicyCodeAllList = <ThrowOnError extends boolean = false>(options?: Options<WelloPolicyCodeAllListData, ThrowOnError>) => (options?.client ?? client).get<WelloPolicyCodeAllListResponses, WelloPolicyCodeAllListErrors, ThrowOnError>({ url: '/wello/v2/allows/wello-policy-code/all', ...options });

/**
 * 웰로 랜딩페이지 데이터 조회
 */
export const detailWelloLanding = <ThrowOnError extends boolean = false>(options?: Options<DetailWelloLandingData, ThrowOnError>) => (options?.client ?? client).get<DetailWelloLandingResponses, DetailWelloLandingErrors, ThrowOnError>({ url: '/wello/v2/allows/wello-landing', ...options });

/**
 * 댓글 목록 조회
 */
export const getMetaPolicyCommentList = <ThrowOnError extends boolean = false>(options: Options<GetMetaPolicyCommentListData, ThrowOnError>) => (options.client ?? client).get<GetMetaPolicyCommentListResponses, GetMetaPolicyCommentListErrors, ThrowOnError>({ url: '/wello/v2/allows/wello-comment', ...options });

/**
 * 댓글 상세 조회
 */
export const getMetaPolicyCommentList1 = <ThrowOnError extends boolean = false>(options: Options<GetMetaPolicyCommentList1Data, ThrowOnError>) => (options.client ?? client).get<GetMetaPolicyCommentList1Responses, GetMetaPolicyCommentList1Errors, ThrowOnError>({ url: '/wello/v2/allows/wello-comment/{welloCommentId}', ...options });

/**
 * 웰로 실시간 정책 의견
 *
 * @deprecated
 */
export const getLiveWelloCommentList = <ThrowOnError extends boolean = false>(options?: Options<GetLiveWelloCommentListData, ThrowOnError>) => (options?.client ?? client).get<GetLiveWelloCommentListResponses, GetLiveWelloCommentListErrors, ThrowOnError>({ url: '/wello/v2/allows/wello-comment/live', ...options });

/**
 * 웰로 앱 푸시 알림 건수 조회
 */
export const newWelloAppPushCnt = <ThrowOnError extends boolean = false>(options: Options<NewWelloAppPushCntData, ThrowOnError>) => (options.client ?? client).get<NewWelloAppPushCntResponses, NewWelloAppPushCntErrors, ThrowOnError>({ url: '/wello/v2/allows/wello-app-push/count', ...options });

/**
 * 웰컴 모니터 노출 대상 조회
 */
export const getWelcomeMonitorDisplayList = <ThrowOnError extends boolean = false>(options: Options<GetWelcomeMonitorDisplayListData, ThrowOnError>) => (options.client ?? client).get<GetWelcomeMonitorDisplayListResponses, GetWelcomeMonitorDisplayListErrors, ThrowOnError>({ url: '/wello/v2/allows/welcome-monitor', ...options });

/**
 * URL 매핑 상세 조회
 *
 * URL 매핑 상세 조회
 */
export const getUrlMapping = <ThrowOnError extends boolean = false>(options: Options<GetUrlMappingData, ThrowOnError>) => (options.client ?? client).get<GetUrlMappingResponses, GetUrlMappingErrors, ThrowOnError>({ url: '/wello/v2/allows/url-mapping/{id}', ...options });

/**
 * 투어 거리 조회 (비로그인 허용)
 *
 * subRegionCode 중심 좌표로부터 투어 point 까지의 거리(미터)를 계산한다. 중심 좌표 미존재 시 30404, 좌표 손상 시 30400, 투어 미존재/비공개 시 30404. point 없으면 distance=null.
 */
export const findTourDistance = <ThrowOnError extends boolean = false>(options: Options<FindTourDistanceData, ThrowOnError>) => (options.client ?? client).get<FindTourDistanceResponses, FindTourDistanceErrors, ThrowOnError>({ url: '/wello/v2/allows/tour/{tourId}/distance', ...options });

/**
 * 투어 조회수/스크랩 정보 조회 (비로그인 허용)
 *
 * Tour 의 조회수/스크랩 정보를 조회한다.
 */
export const findTourFeedback = <ThrowOnError extends boolean = false>(options: Options<FindTourFeedbackData, ThrowOnError>) => (options.client ?? client).get<FindTourFeedbackResponses, FindTourFeedbackErrors, ThrowOnError>({ url: '/wello/v2/allows/tour/feedback/{tourId}', ...options });

/**
 * 약관을 조회합니다.
 *
 * 약관 조회
 */
export const term = <ThrowOnError extends boolean = false>(options: Options<TermData, ThrowOnError>) => (options.client ?? client).get<TermResponses, TermErrors, ThrowOnError>({ url: '/wello/v2/allows/term/{termCategory}', ...options });

/**
 * 비회원 파일 복호화 다운로드
 */
export const fileDecryptionDownload = <ThrowOnError extends boolean = false>(options: Options<FileDecryptionDownloadData, ThrowOnError>) => (options.client ?? client).get<FileDecryptionDownloadResponses, FileDecryptionDownloadErrors, ThrowOnError>({ url: '/wello/v2/allows/s3/nonmember-decryption', ...options });

/**
 * 축제 위치 기반 목록
 *
 * subRegionCode 좌표 기준 radius(미터) 내 축제를 거리 ASC로 정렬해 반환한다. 응답은 distance(미터)를 포함한다.
 */
export const findTourFestivals = <ThrowOnError extends boolean = false>(options: Options<FindTourFestivalsData, ThrowOnError>) => (options.client ?? client).get<FindTourFestivalsResponses, FindTourFestivalsErrors, ThrowOnError>({ url: '/wello/v2/allows/query/tour/festival', ...options });

/**
 * 정책 검색
 */
export const findPolicies = <ThrowOnError extends boolean = false>(options?: Options<FindPoliciesData, ThrowOnError>) => (options?.client ?? client).get<FindPoliciesResponses, FindPoliciesErrors, ThrowOnError>({ url: '/wello/v2/allows/query/policies', ...options });

/**
 * 정책 검색 - 대상
 */
export const findQueryTargetCode = <ThrowOnError extends boolean = false>(options?: Options<FindQueryTargetCodeData, ThrowOnError>) => (options?.client ?? client).get<FindQueryTargetCodeResponses, FindQueryTargetCodeErrors, ThrowOnError>({ url: '/wello/v2/allows/query/policies/codes/target', ...options });

/**
 * 정책 검색, 정책 활용 가이드 - 지원형태
 */
export const findQueryProvisionCode = <ThrowOnError extends boolean = false>(options?: Options<FindQueryProvisionCodeData, ThrowOnError>) => (options?.client ?? client).get<FindQueryProvisionCodeResponses, FindQueryProvisionCodeErrors, ThrowOnError>({ url: '/wello/v2/allows/query/policies/codes/provision', ...options });

/**
 * 정책 검색 - 직업
 */
export const findQueryJobCode = <ThrowOnError extends boolean = false>(options?: Options<FindQueryJobCodeData, ThrowOnError>) => (options?.client ?? client).get<FindQueryJobCodeResponses, FindQueryJobCodeErrors, ThrowOnError>({ url: '/wello/v2/allows/query/policies/codes/job', ...options });

/**
 * 정책 검색 - 연령
 */
export const findQueryAgeCode = <ThrowOnError extends boolean = false>(options?: Options<FindQueryAgeCodeData, ThrowOnError>) => (options?.client ?? client).get<FindQueryAgeCodeResponses, FindQueryAgeCodeErrors, ThrowOnError>({ url: '/wello/v2/allows/query/policies/codes/age', ...options });

/**
 * 웰마켓 검색
 */
export const findLocalMarketProducts = <ThrowOnError extends boolean = false>(options?: Options<FindLocalMarketProductsData, ThrowOnError>) => (options?.client ?? client).get<FindLocalMarketProductsResponses, FindLocalMarketProductsErrors, ThrowOnError>({ url: '/wello/v2/allows/query/local-market', ...options });

/**
 * 동네소식 검색
 */
export const findHometownNews = <ThrowOnError extends boolean = false>(options?: Options<FindHometownNewsData, ThrowOnError>) => (options?.client ?? client).get<FindHometownNewsResponses, FindHometownNewsErrors, ThrowOnError>({ url: '/wello/v2/allows/query/hometown-news', ...options });

/**
 * 답례품 검색
 */
export const findGiftProducts = <ThrowOnError extends boolean = false>(options?: Options<FindGiftProductsData, ThrowOnError>) => (options?.client ?? client).get<FindGiftProductsResponses, FindGiftProductsErrors, ThrowOnError>({ url: '/wello/v2/allows/query/gift-products', ...options });

/**
 * 지정기부사업 검색
 */
export const findDonationBusinesses = <ThrowOnError extends boolean = false>(options?: Options<FindDonationBusinessesData, ThrowOnError>) => (options?.client ?? client).get<FindDonationBusinessesResponses, FindDonationBusinessesErrors, ThrowOnError>({ url: '/wello/v2/allows/query/donations-businesses', ...options });

/**
 * 정책소식 검색
 */
export const findBestContents = <ThrowOnError extends boolean = false>(options: Options<FindBestContentsData, ThrowOnError>) => (options.client ?? client).get<FindBestContentsResponses, FindBestContentsErrors, ThrowOnError>({ url: '/wello/v2/allows/query/best-contents', ...options });

/**
 * 비회원 정책 상세 조회
 */
export const metaPolicy = <ThrowOnError extends boolean = false>(options: Options<MetaPolicyData, ThrowOnError>) => (options.client ?? client).get<MetaPolicyResponses, MetaPolicyErrors, ThrowOnError>({ url: '/wello/v2/allows/policy/{metaPolicyIdIdx}', ...options });

/**
 * 비회원 인기정책 조회
 */
export const popularPolicyList = <ThrowOnError extends boolean = false>(options?: Options<PopularPolicyListData, ThrowOnError>) => (options?.client ?? client).get<PopularPolicyListResponses, PopularPolicyListErrors, ThrowOnError>({ url: '/wello/v2/allows/policy/popular', ...options });

/**
 * 비로그인 멤버 정책 좋아요&스크랩 정보 조회
 */
export const metaPolicyFeedback = <ThrowOnError extends boolean = false>(options: Options<MetaPolicyFeedbackData, ThrowOnError>) => (options.client ?? client).get<MetaPolicyFeedbackResponses, MetaPolicyFeedbackErrors, ThrowOnError>({ url: '/wello/v2/allows/policy/feedback/{policyId}', ...options });

/**
 * 정책 사전 목록 조회
 */
export const getPolicyDictionaryList = <ThrowOnError extends boolean = false>(options?: Options<GetPolicyDictionaryListData, ThrowOnError>) => (options?.client ?? client).get<GetPolicyDictionaryListResponses, GetPolicyDictionaryListErrors, ThrowOnError>({ url: '/wello/v2/allows/policy-dictionary', ...options });

/**
 * 지역 좌표 목록 조회
 */
export const getPolicyCodeGeocodingList = <ThrowOnError extends boolean = false>(options?: Options<GetPolicyCodeGeocodingListData, ThrowOnError>) => (options?.client ?? client).get<GetPolicyCodeGeocodingListResponses, GetPolicyCodeGeocodingListErrors, ThrowOnError>({ url: '/wello/v2/allows/policy-code-geocoding', ...options });

/**
 * 내 상황에 맞는 정책 카테고리
 */
export const getListPolicyCaseCategory = <ThrowOnError extends boolean = false>(options?: Options<GetListPolicyCaseCategoryData, ThrowOnError>) => (options?.client ?? client).get<GetListPolicyCaseCategoryResponses, GetListPolicyCaseCategoryErrors, ThrowOnError>({ url: '/wello/v2/allows/policy-case/category', ...options });

/**
 * 홈 - 정책 바로신청 조회
 */
export const getHomeWelloPolicyApplyList = <ThrowOnError extends boolean = false>(options: Options<GetHomeWelloPolicyApplyListData, ThrowOnError>) => (options.client ?? client).get<GetHomeWelloPolicyApplyListResponses, GetHomeWelloPolicyApplyListErrors, ThrowOnError>({ url: '/wello/v2/allows/policy-apply/home', ...options });

/**
 * 타입별 포인트 조회
 *
 * 타입별 포인트 적립/사용 정보 조회
 */
export const getPointInfo = <ThrowOnError extends boolean = false>(options: Options<GetPointInfoData, ThrowOnError>) => (options.client ?? client).get<GetPointInfoResponses, GetPointInfoErrors, ThrowOnError>({ url: '/wello/v2/allows/point/info', ...options });

/**
 * 포인트 획득 조회
 *
 * 유저 액션 별 획득 가능 포인트를 조회합니다.
 */
export const getPointEarning = <ThrowOnError extends boolean = false>(options?: Options<GetPointEarningData, ThrowOnError>) => (options?.client ?? client).get<GetPointEarningResponses, GetPointEarningErrors, ThrowOnError>({ url: '/wello/v2/allows/point/earning', ...options });

/**
 * 예산 포인트 정보 조회
 *
 * 포인트 잔액, 출금 가능 포인트를 조회합니다.
 */
export const getPointBudget = <ThrowOnError extends boolean = false>(options?: Options<GetPointBudgetData, ThrowOnError>) => (options?.client ?? client).get<GetPointBudgetResponses, GetPointBudgetErrors, ThrowOnError>({ url: '/wello/v2/allows/point/budget', ...options });

/**
 * 상품 목록 조회
 */
export const getPointMarketProductList = <ThrowOnError extends boolean = false>(options?: Options<GetPointMarketProductListData, ThrowOnError>) => (options?.client ?? client).get<GetPointMarketProductListResponses, GetPointMarketProductListErrors, ThrowOnError>({ url: '/wello/v2/allows/point-market/product', ...options });

/**
 * 상품 상세 조회(+ 지금 본 상품과 비슷한 상품 목록)
 */
export const getPointMarketProduct = <ThrowOnError extends boolean = false>(options: Options<GetPointMarketProductData, ThrowOnError>) => (options.client ?? client).get<GetPointMarketProductResponses, GetPointMarketProductErrors, ThrowOnError>({ url: '/wello/v2/allows/point-market/product/{productIdIdx}', ...options });

/**
 * 인기 상품 목록 조회 (top 6)
 */
export const getPopularPointMarketProductList = <ThrowOnError extends boolean = false>(options?: Options<GetPopularPointMarketProductListData, ThrowOnError>) => (options?.client ?? client).get<GetPopularPointMarketProductListResponses, GetPopularPointMarketProductListErrors, ThrowOnError>({ url: '/wello/v2/allows/point-market/product/popular', ...options });

/**
 * 브랜드별 상품 목록 조회 (페이징 없음)
 */
export const getPointMarketProductListByBrand = <ThrowOnError extends boolean = false>(options?: Options<GetPointMarketProductListByBrandData, ThrowOnError>) => (options?.client ?? client).get<GetPointMarketProductListByBrandResponses, GetPointMarketProductListByBrandErrors, ThrowOnError>({ url: '/wello/v2/allows/point-market/product/by-brand', ...options });

/**
 * 카테고리별 브랜드 목록 조회
 */
export const getPointMarketBrandList = <ThrowOnError extends boolean = false>(options?: Options<GetPointMarketBrandListData, ThrowOnError>) => (options?.client ?? client).get<GetPointMarketBrandListResponses, GetPointMarketBrandListErrors, ThrowOnError>({ url: '/wello/v2/allows/point-market/brand', ...options });

/**
 * 웰로픽! 요즘 뜨는 정책 목록 조회
 *
 * 웰로픽 - 메인 정책 큐레이션 목록을 조회합니다
 */
export const getWelloPickBannerList = <ThrowOnError extends boolean = false>(options?: Options<GetWelloPickBannerListData, ThrowOnError>) => (options?.client ?? client).get<GetWelloPickBannerListResponses, GetWelloPickBannerListErrors, ThrowOnError>({ url: '/wello/v2/allows/pick', ...options });

/**
 * 비회원 맞춤 정책 검색목록 조회
 */
export const getNonMemberSuggestPolicyList = <ThrowOnError extends boolean = false>(options: Options<GetNonMemberSuggestPolicyListData, ThrowOnError>) => (options.client ?? client).get<GetNonMemberSuggestPolicyListResponses, GetNonMemberSuggestPolicyListErrors, ThrowOnError>({ url: '/wello/v2/allows/non-member-suggest-policy', ...options });

/**
 * Nice 신용인증 성공시 이동될 URL
 */
export const checkPlusSuccess = <ThrowOnError extends boolean = false>(options: Options<CheckPlusSuccessData, ThrowOnError>) => (options.client ?? client).get<CheckPlusSuccessResponses, CheckPlusSuccessErrors, ThrowOnError>({ url: '/wello/v2/allows/nice-safe-key/check-plus_success', ...options });

/**
 * 메타코드 정보 조회
 *
 * 메타코드 및 메타코드의 하위 코드까지 조회합니다
 */
export const metaCodeAll = <ThrowOnError extends boolean = false>(options: Options<MetaCodeAllData, ThrowOnError>) => (options.client ?? client).get<MetaCodeAllResponses, MetaCodeAllErrors, ThrowOnError>({ url: '/wello/v2/allows/meta-code', ...options });

/**
 * 신규 닉네임 조회
 *
 * 신규 닉네임을 조회합니다
 */
export const noticeList = <ThrowOnError extends boolean = false>(options?: Options<NoticeListData, ThrowOnError>) => (options?.client ?? client).get<NoticeListResponses, NoticeListErrors, ThrowOnError>({ url: '/wello/v2/allows/member-wello/nickname', ...options });

export const snsRefreshToken = <ThrowOnError extends boolean = false>(options: Options<SnsRefreshTokenData, ThrowOnError>) => (options.client ?? client).get<SnsRefreshTokenResponses, SnsRefreshTokenErrors, ThrowOnError>({ url: '/wello/v2/allows/member-oauth/sns/refresh-token', ...options });

export const getKbMemberLoginTypeList = <ThrowOnError extends boolean = false>(options: Options<GetKbMemberLoginTypeListData, ThrowOnError>) => (options.client ?? client).get<GetKbMemberLoginTypeListResponses, GetKbMemberLoginTypeListErrors, ThrowOnError>({ url: '/wello/v2/allows/member-oauth/kb-member-login-type', ...options });

/**
 * 중위소득 조회
 */
export const getMedianIncomeList = <ThrowOnError extends boolean = false>(options?: Options<GetMedianIncomeListData, ThrowOnError>) => (options?.client ?? client).get<GetMedianIncomeListResponses, GetMedianIncomeListErrors, ThrowOnError>({ url: '/wello/v2/allows/median-income', ...options });

/**
 * 특정 점검 상세 조회
 *
 * 특정 점검 상세 조회
 */
export const getMaintenance = <ThrowOnError extends boolean = false>(options: Options<GetMaintenanceData, ThrowOnError>) => (options.client ?? client).get<GetMaintenanceResponses, GetMaintenanceErrors, ThrowOnError>({ url: '/wello/v2/allows/maintenance/check/{id}', ...options });

/**
 * 현재 활성화된 점검 목록 조회
 *
 * 현재 활성화된 점검 목록 조회
 */
export const getActiveMaintenanceList = <ThrowOnError extends boolean = false>(options?: Options<GetActiveMaintenanceListData, ThrowOnError>) => (options?.client ?? client).get<GetActiveMaintenanceListResponses, GetActiveMaintenanceListErrors, ThrowOnError>({ url: '/wello/v2/allows/maintenance/active', ...options });

/**
 * 약관 변경 이력을 조회합니다.
 *
 * 약관 변경이력 조회
 */
export const termHistory = <ThrowOnError extends boolean = false>(options: Options<TermHistoryData, ThrowOnError>) => (options.client ?? client).get<TermHistoryResponses, TermHistoryErrors, ThrowOnError>({ url: '/wello/v2/allows/log-term/{termCategory}', ...options });

/**
 * 상품 상세 조회
 *
 * 상품 ID(UUID)로 상품 상세 조회.
 *
 * <p>엔드포인트: <code>GET /wello/v2/allows/local-market/products/{productId</code>}</p>
 *
 * <p>Spring이 <code>@PathVariable UUID</code> 타입 변환 시 UUID 형식이 아니면 자동으로 400 에러를 반환한다.</p>
 */
export const getProductDetail = <ThrowOnError extends boolean = false>(options: Options<GetProductDetailData, ThrowOnError>) => (options.client ?? client).get<GetProductDetailResponses, GetProductDetailErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/products/{productId}', ...options });

/**
 * 상품 ID로 SEO 정보 조회 (비인증)
 *
 * 상품 ID(UUID)로 SEO 정보 조회.
 *
 * <p>엔드포인트: <code>GET /wello/v2/allows/local-market/products/{productId</code>/seo}</p>
 */
export const getProductSeoByProductId = <ThrowOnError extends boolean = false>(options: Options<GetProductSeoByProductIdData, ThrowOnError>) => (options.client ?? client).get<GetProductSeoByProductIdResponses, GetProductSeoByProductIdErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/products/{productId}/seo', ...options });

/**
 * 상품 리뷰 목록 조회
 *
 * 상품 ID로 상품 리뷰 목록을 조회한다.
 */
export const findReviews = <ThrowOnError extends boolean = false>(options: Options<FindReviewsData, ThrowOnError>) => (options.client ?? client).get<FindReviewsResponses, FindReviewsErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/products/{productId}/reviews', ...options });

/**
 * 상품 리뷰 상세 조회
 *
 * 상품 리뷰 상세를 조회한다.
 */
export const findReview = <ThrowOnError extends boolean = false>(options: Options<FindReviewData, ThrowOnError>) => (options.client ?? client).get<FindReviewResponses, FindReviewErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/products/{productId}/reviews/{reviewId}', ...options });

/**
 * 상품 포토 리뷰 목록 조회
 *
 * 상품 포토 리뷰 이미지 목록 조회
 */
export const findPhotoReviews = <ThrowOnError extends boolean = false>(options: Options<FindPhotoReviewsData, ThrowOnError>) => (options.client ?? client).get<FindPhotoReviewsResponses, FindPhotoReviewsErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/products/{productId}/reviews/photos', ...options });

/**
 * 상품 문의 목록 조회
 *
 * 상품 문의 목록 조회
 */
export const findAllInquiries = <ThrowOnError extends boolean = false>(options: Options<FindAllInquiriesData, ThrowOnError>) => (options.client ?? client).get<FindAllInquiriesResponses, FindAllInquiriesErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/products/{productId}/inquiries', ...options });

/**
 * 상품 문의 상세 조회
 *
 * 상품 문의 상세 조회
 */
export const findInquiry = <ThrowOnError extends boolean = false>(options: Options<FindInquiryData, ThrowOnError>) => (options.client ?? client).get<FindInquiryResponses, FindInquiryErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/products/{productId}/inquiries/{inquiryId}', ...options });

/**
 * 상품번호로 상품 상세 조회
 *
 * 상품번호로 상품 상세 조회.
 *
 * <p>엔드포인트: <code>GET /wello/v2/allows/local-market/products/by-product-number/{productNumber</code>}</p>
 *
 * <p>상품번호(productNumber)는 상품 등록 시 자동 생성되는 고유 식별자이다.
 * 컨트롤러 레벨에서 정규식 패턴을 검증하여, 형식에 맞지 않는 요청은
 * DB 조회 없이 즉시 에러를 반환한다.</p>
 */
export const getProductDetailByProductNumber = <ThrowOnError extends boolean = false>(options: Options<GetProductDetailByProductNumberData, ThrowOnError>) => (options.client ?? client).get<GetProductDetailByProductNumberResponses, GetProductDetailByProductNumberErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/products/by-product-number/{productNumber}', ...options });

/**
 * 상품번호로 SEO 정보 조회 (비인증)
 *
 * 상품번호로 SEO 정보 조회.
 *
 * <p>엔드포인트: <code>GET /wello/v2/allows/local-market/products/by-product-number/{productNumber</code>/seo}</p>
 */
export const getProductSeo = <ThrowOnError extends boolean = false>(options: Options<GetProductSeoData, ThrowOnError>) => (options.client ?? client).get<GetProductSeoResponses, GetProductSeoErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/products/by-product-number/{productNumber}/seo', ...options });

/**
 * 상품 피드 목록 조회 (메인)
 *
 * 상품 피드 목록 조회.
 *
 * <p>엔드포인트: <code>GET /wello/v2/allows/local-market/product-feeds</code></p>
 *
 * <p>판매중인 상품을 페이징하여 조회합니다.
 * 태그(프리미엄/최저가도전/무료배송), 리뷰 통계, 가격/할인 정보를 포함합니다.</p>
 */
export const getProductFeedList = <ThrowOnError extends boolean = false>(options?: Options<GetProductFeedListData, ThrowOnError>) => (options?.client ?? client).get<GetProductFeedListResponses, GetProductFeedListErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/product-feeds', ...options });

/**
 * 기부자 만족 상품 피드 조회 (메인 화면)
 *
 * 기부자 만족 상품 피드 조회.
 *
 * <p>상품 ID로 매핑된 답례품의 기부자 만족도와 리뷰 미리보기를 반환합니다.
 * 리뷰는 최신순 N건만 반환됩니다.</p>
 */
export const getGiftReviewFeed = <ThrowOnError extends boolean = false>(options: Options<GetGiftReviewFeedData, ThrowOnError>) => (options.client ?? client).get<GetGiftReviewFeedResponses, GetGiftReviewFeedErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/gift-review-feed/{productId}', ...options });

/**
 * 일반 다운로드 가능 쿠폰 목록 조회 (공개)
 *
 * 비인증 사용자용 상품별 일반 다운로드 가능 쿠폰 목록 조회
 */
export const findGeneralDownloadableCoupons = <ThrowOnError extends boolean = false>(options: Options<FindGeneralDownloadableCouponsData, ThrowOnError>) => (options.client ?? client).get<FindGeneralDownloadableCouponsResponses, FindGeneralDownloadableCouponsErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/coupons/downloadable', ...options });

/**
 * 지역별 특산품
 */
export const getInstitutionSpecialtyList = <ThrowOnError extends boolean = false>(options?: Options<GetInstitutionSpecialtyListData, ThrowOnError>) => (options?.client ?? client).get<GetInstitutionSpecialtyListResponses, GetInstitutionSpecialtyListErrors, ThrowOnError>({ url: '/wello/v2/allows/local-festa/institution-specialty', ...options });

/**
 * 관심 분야별 정책 조회
 */
export const allowsInterestPolicyList = <ThrowOnError extends boolean = false>(options: Options<AllowsInterestPolicyListData, ThrowOnError>) => (options.client ?? client).get<AllowsInterestPolicyListResponses, AllowsInterestPolicyListErrors, ThrowOnError>({ url: '/wello/v2/allows/interest-policy', ...options });

/**
 * 동네 소식 상세
 */
export const hometownNews = <ThrowOnError extends boolean = false>(options: Options<HometownNewsData, ThrowOnError>) => (options.client ?? client).get<HometownNewsResponses, HometownNewsErrors, ThrowOnError>({ url: '/wello/v2/allows/hometown-news/{hometownNewsIdIdx}', ...options });

/**
 * 관련 동네소식 목록 조회(최대 10개)
 */
export const getRelatedHometownNewsList = <ThrowOnError extends boolean = false>(options: Options<GetRelatedHometownNewsListData, ThrowOnError>) => (options.client ?? client).get<GetRelatedHometownNewsListResponses, GetRelatedHometownNewsListErrors, ThrowOnError>({ url: '/wello/v2/allows/hometown-news/{hometownNewsIdIdx}/related', ...options });

/**
 * 비로그인 멤버 동네 소식 좋아요&스크랩 정보 조회
 */
export const hometownNewsFeedback = <ThrowOnError extends boolean = false>(options: Options<HometownNewsFeedbackData, ThrowOnError>) => (options.client ?? client).get<HometownNewsFeedbackResponses, HometownNewsFeedbackErrors, ThrowOnError>({ url: '/wello/v2/allows/hometown-news/feedback/{hometownNewsId}', ...options });

/**
 * 지자체 정보 조회
 */
export const getHomeInstitution = <ThrowOnError extends boolean = false>(options: Options<GetHomeInstitutionData, ThrowOnError>) => (options.client ?? client).get<GetHomeInstitutionResponses, GetHomeInstitutionErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution/{institutionId}', ...options });

/**
 * 위경도 기반 혜택 제공기관 지역별 갯수 검색
 */
export const getHomeInstitutionBenefitRegionList = <ThrowOnError extends boolean = false>(options: Options<GetHomeInstitutionBenefitRegionListData, ThrowOnError>) => (options.client ?? client).get<GetHomeInstitutionBenefitRegionListResponses, GetHomeInstitutionBenefitRegionListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution/{homeLoveGovCode}/region', ...options });

/**
 * 위경도 기반 혜택 제공기관 검색
 */
export const getHomeInstitutionBenefitList = <ThrowOnError extends boolean = false>(options: Options<GetHomeInstitutionBenefitListData, ThrowOnError>) => (options.client ?? client).get<GetHomeInstitutionBenefitListResponses, GetHomeInstitutionBenefitListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution/{homeLoveGovCode}/benefit', ...options });

/**
 * 위경도 기반 혜텍 제공기관 전체 검색
 */
export const getHomeInstitutionBenefitListAll = <ThrowOnError extends boolean = false>(options: Options<GetHomeInstitutionBenefitListAllData, ThrowOnError>) => (options.client ?? client).get<GetHomeInstitutionBenefitListAllResponses, GetHomeInstitutionBenefitListAllErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution/{homeLoveGovCode}/benefit/all', ...options });

/**
 * 위경도 기반 혜텍 제공기관 - 공영
 */
export const getHomeInstitutionBenefitPublicList = <ThrowOnError extends boolean = false>(options: Options<GetHomeInstitutionBenefitPublicListData, ThrowOnError>) => (options.client ?? client).get<GetHomeInstitutionBenefitPublicListResponses, GetHomeInstitutionBenefitPublicListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution/{homeLoveGovCode}/benefit/all/public', ...options });

/**
 * 위경도 기반 혜텍 제공기관 - 민영
 */
export const getHomeInstitutionBenefitPrivateList = <ThrowOnError extends boolean = false>(options: Options<GetHomeInstitutionBenefitPrivateListData, ThrowOnError>) => (options.client ?? client).get<GetHomeInstitutionBenefitPrivateListResponses, GetHomeInstitutionBenefitPrivateListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution/{homeLoveGovCode}/benefit/all/private', ...options });

/**
 * 지자체 정책 목록 조회
 */
export const getHomeInstitutionPolicyList = <ThrowOnError extends boolean = false>(options: Options<GetHomeInstitutionPolicyListData, ThrowOnError>) => (options.client ?? client).get<GetHomeInstitutionPolicyListResponses, GetHomeInstitutionPolicyListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution/policy', ...options });

/**
 * 지자체 목록 조회(검색필터용)
 */
export const getHomeInstitutionListForSearchFilter = <ThrowOnError extends boolean = false>(options?: Options<GetHomeInstitutionListForSearchFilterData, ThrowOnError>) => (options?.client ?? client).get<GetHomeInstitutionListForSearchFilterResponses, GetHomeInstitutionListForSearchFilterErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution/for-search-filter', ...options });

/**
 * 지자체 코드로 ID 조회
 */
export const getHomeLoveGovCodeToId = <ThrowOnError extends boolean = false>(options: Options<GetHomeLoveGovCodeToIdData, ThrowOnError>) => (options.client ?? client).get<GetHomeLoveGovCodeToIdResponses, GetHomeLoveGovCodeToIdErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution/code-to-id/{homeLoveGovCode}', ...options });

/**
 * 지자체 이벤트 목록 조회
 */
export const getHomeInstitutionEventList = <ThrowOnError extends boolean = false>(options?: Options<GetHomeInstitutionEventListData, ThrowOnError>) => (options?.client ?? client).get<GetHomeInstitutionEventListResponses, GetHomeInstitutionEventListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution-event', ...options });

/**
 * 지자체 이벤트 상세 조회
 */
export const getHomeInstitutionEvent = <ThrowOnError extends boolean = false>(options: Options<GetHomeInstitutionEventData, ThrowOnError>) => (options.client ?? client).get<GetHomeInstitutionEventResponses, GetHomeInstitutionEventErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution-event/{institutionEventId}', ...options });

/**
 * 지자체 이벤트 목록 조회(정렬)
 */
export const getOrderedHomeInstitutionEventList = <ThrowOnError extends boolean = false>(options?: Options<GetOrderedHomeInstitutionEventListData, ThrowOnError>) => (options?.client ?? client).get<GetOrderedHomeInstitutionEventListResponses, GetOrderedHomeInstitutionEventListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution-event/ordered', ...options });

/**
 * 지자체 컨텐츠 목록 조회
 */
export const getHomeInstitutionContentList = <ThrowOnError extends boolean = false>(options?: Options<GetHomeInstitutionContentListData, ThrowOnError>) => (options?.client ?? client).get<GetHomeInstitutionContentListResponses, GetHomeInstitutionContentListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution-content', ...options });

/**
 * 지자체 컨텐츠 상세 조회
 */
export const getHomeInstitutionContent = <ThrowOnError extends boolean = false>(options: Options<GetHomeInstitutionContentData, ThrowOnError>) => (options.client ?? client).get<GetHomeInstitutionContentResponses, GetHomeInstitutionContentErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution-content/{institutionContentId}', ...options });

/**
 * 리뷰 목록 조회
 */
export const getGiftOrderProductReviewList = <ThrowOnError extends boolean = false>(options?: Options<GetGiftOrderProductReviewListData, ThrowOnError>) => (options?.client ?? client).get<GetGiftOrderProductReviewListResponses, GetGiftOrderProductReviewListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-review', ...options });

/**
 * 리뷰 상세 조회
 */
export const getGiftOrderProductReview = <ThrowOnError extends boolean = false>(options: Options<GetGiftOrderProductReviewData, ThrowOnError>) => (options.client ?? client).get<GetGiftOrderProductReviewResponses, GetGiftOrderProductReviewErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-review/{reviewId}', ...options });

/**
 * 후기 목록(포토리뷰) 조회
 */
export const getGiftOrderProductPhotoReviewListByProduct = <ThrowOnError extends boolean = false>(options?: Options<GetGiftOrderProductPhotoReviewListByProductData, ThrowOnError>) => (options?.client ?? client).get<GetGiftOrderProductPhotoReviewListByProductResponses, GetGiftOrderProductPhotoReviewListByProductErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-review/photo', ...options });

/**
 * 답례품 목록 조회
 */
export const getGiftProductList1 = <ThrowOnError extends boolean = false>(options?: Options<GetGiftProductList1Data, ThrowOnError>) => (options?.client ?? client).get<GetGiftProductList1Responses, GetGiftProductList1Errors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-product', ...options });

/**
 * 답례품 상세 조회
 */
export const getGiftProduct = <ThrowOnError extends boolean = false>(options: Options<GetGiftProductData, ThrowOnError>) => (options.client ?? client).get<GetGiftProductResponses, GetGiftProductErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-product/{productNumber}', ...options });

/**
 * 관련 답례품 목록(동일 지자체) 조회(top 4)
 */
export const getRelatedGiftProductList = <ThrowOnError extends boolean = false>(options: Options<GetRelatedGiftProductListData, ThrowOnError>) => (options.client ?? client).get<GetRelatedGiftProductListResponses, GetRelatedGiftProductListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-product/{productNumber}/related', ...options });

/**
 * 답례품 목록 조회(동일, 처음 문자열 일치)
 */
export const searchGiftProductList = <ThrowOnError extends boolean = false>(options: Options<SearchGiftProductListData, ThrowOnError>) => (options.client ?? client).get<SearchGiftProductListResponses, SearchGiftProductListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-product/search', ...options });

/**
 * 답례품 목록 조회 총 건수
 */
export const searchGiftProductListCount = <ThrowOnError extends boolean = false>(options: Options<SearchGiftProductListCountData, ThrowOnError>) => (options.client ?? client).get<SearchGiftProductListCountResponses, SearchGiftProductListCountErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-product/search/total-count', ...options });

/**
 * 답례품 목록 조회 - 포함(동일, 시작 문자열 제외)
 */
export const searchGiftProductListByContains = <ThrowOnError extends boolean = false>(options: Options<SearchGiftProductListByContainsData, ThrowOnError>) => (options.client ?? client).get<SearchGiftProductListByContainsResponses, SearchGiftProductListByContainsErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-product/search/contains', ...options });

/**
 * 특정 지자체 답례품 목록
 */
export const getInstitutionGiftProductList = <ThrowOnError extends boolean = false>(options: Options<GetInstitutionGiftProductListData, ThrowOnError>) => (options.client ?? client).get<GetInstitutionGiftProductListResponses, GetInstitutionGiftProductListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-product/related', ...options });

/**
 * 지자체별 인기 답례품 조회
 */
export const getGiftProductPopularByInstitutionList = <ThrowOnError extends boolean = false>(options?: Options<GetGiftProductPopularByInstitutionListData, ThrowOnError>) => (options?.client ?? client).get<GetGiftProductPopularByInstitutionListResponses, GetGiftProductPopularByInstitutionListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-product/popular', ...options });

/**
 * 지자체 답례품 목록 조회
 */
export const getGiftProductListByInstitution = <ThrowOnError extends boolean = false>(options: Options<GetGiftProductListByInstitutionData, ThrowOnError>) => (options.client ?? client).get<GetGiftProductListByInstitutionResponses, GetGiftProductListByInstitutionErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-product/by-institution', ...options });

/**
 * 답례품 목록 조회(포토리뷰 포함)
 */
export const getGiftProductBlockList = <ThrowOnError extends boolean = false>(options: Options<GetGiftProductBlockListData, ThrowOnError>) => (options.client ?? client).get<GetGiftProductBlockListResponses, GetGiftProductBlockListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-product/block', ...options });

/**
 * 답례품 seo 조회
 */
export const getGiftProductSeo = <ThrowOnError extends boolean = false>(options: Options<GetGiftProductSeoData, ThrowOnError>) => (options.client ?? client).get<GetGiftProductSeoResponses, GetGiftProductSeoErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-product-seo/{productNumber}', ...options });

/**
 * 답례품 카테고리 최상위 목록 조회
 */
export const getPrimaryGiftCategoryList = <ThrowOnError extends boolean = false>(options?: Options<GetPrimaryGiftCategoryListData, ThrowOnError>) => (options?.client ?? client).get<GetPrimaryGiftCategoryListResponses, GetPrimaryGiftCategoryListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-category/primary', ...options });

/**
 * 랜덤티켓 당첨자 (3등 이상)
 */
export const getDecemberRandomTicketWinnerList = <ThrowOnError extends boolean = false>(options?: Options<GetDecemberRandomTicketWinnerListData, ThrowOnError>) => (options?.client ?? client).get<GetDecemberRandomTicketWinnerListResponses, GetDecemberRandomTicketWinnerListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/event/december/random-ticket-winner', ...options });

/**
 * 지역별 기부 이벤트 현황
 */
export const getDecemberInstitutionEventInfoList = <ThrowOnError extends boolean = false>(options?: Options<GetDecemberInstitutionEventInfoListData, ThrowOnError>) => (options?.client ?? client).get<GetDecemberInstitutionEventInfoListResponses, GetDecemberInstitutionEventInfoListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/event/december/institution-event', ...options });

/**
 * 금일 Event2 답례품
 */
export const getDecemberEventGiftProductList = <ThrowOnError extends boolean = false>(options?: Options<GetDecemberEventGiftProductListData, ThrowOnError>) => (options?.client ?? client).get<GetDecemberEventGiftProductListResponses, GetDecemberEventGiftProductListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/event/december/gift-product', ...options });

/**
 * 12월 혜택 금액 정보 조회
 */
export const getEventAmountInfo = <ThrowOnError extends boolean = false>(options?: Options<GetEventAmountInfoData, ThrowOnError>) => (options?.client ?? client).get<GetEventAmountInfoResponses, GetEventAmountInfoErrors, ThrowOnError>({ url: '/wello/v2/allows/home/event/december/benefit-amount', ...options });

/**
 * 지정 사업 목록
 */
export const getDonationBusinessList = <ThrowOnError extends boolean = false>(options?: Options<GetDonationBusinessListData, ThrowOnError>) => (options?.client ?? client).get<GetDonationBusinessListResponses, GetDonationBusinessListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/donation-business', ...options });

/**
 * 지정 사업 상세
 */
export const getDonationBusiness = <ThrowOnError extends boolean = false>(options: Options<GetDonationBusinessData, ThrowOnError>) => (options.client ?? client).get<GetDonationBusinessResponses, GetDonationBusinessErrors, ThrowOnError>({ url: '/wello/v2/allows/home/donation-business/{donationBusinessId}', ...options });

/**
 * 관련 지정 사업 목록
 */
export const getRelatedDonationBusiness = <ThrowOnError extends boolean = false>(options: Options<GetRelatedDonationBusinessData, ThrowOnError>) => (options.client ?? client).get<GetRelatedDonationBusinessResponses, GetRelatedDonationBusinessErrors, ThrowOnError>({ url: '/wello/v2/allows/home/donation-business/{donationBusinessId}/related', ...options });

/**
 * 지정 사업 상세 - 기부 & 응원 수 조회
 */
export const getDonationBusinessDetailCount = <ThrowOnError extends boolean = false>(options: Options<GetDonationBusinessDetailCountData, ThrowOnError>) => (options.client ?? client).get<GetDonationBusinessDetailCountResponses, GetDonationBusinessDetailCountErrors, ThrowOnError>({ url: '/wello/v2/allows/home/donation-business/{donationBusinessId}/detail-count', ...options });

/**
 * 특정 지자체 지정 사업 목록
 */
export const getInstitutionRelatedDonationBusiness = <ThrowOnError extends boolean = false>(options: Options<GetInstitutionRelatedDonationBusinessData, ThrowOnError>) => (options.client ?? client).get<GetInstitutionRelatedDonationBusinessResponses, GetInstitutionRelatedDonationBusinessErrors, ThrowOnError>({ url: '/wello/v2/allows/home/donation-business/related', ...options });

/**
 * 지자체 기부 가능한 지정 사업 조회
 */
export const getHomeInstitutionDonationBusiness = <ThrowOnError extends boolean = false>(options: Options<GetHomeInstitutionDonationBusinessData, ThrowOnError>) => (options.client ?? client).get<GetHomeInstitutionDonationBusinessResponses, GetHomeInstitutionDonationBusinessErrors, ThrowOnError>({ url: '/wello/v2/allows/home/donation-business/institution/{institutionId}', ...options });

/**
 * 지정사업 응원하기 목록
 */
export const getDonationBusinessCommentList = <ThrowOnError extends boolean = false>(options: Options<GetDonationBusinessCommentListData, ThrowOnError>) => (options.client ?? client).get<GetDonationBusinessCommentListResponses, GetDonationBusinessCommentListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/donation-business-comment', ...options });

/**
 * 검색 키워드 목록 조회
 */
export const getAdminHomeSearchKeywordList = <ThrowOnError extends boolean = false>(options: Options<GetAdminHomeSearchKeywordListData, ThrowOnError>) => (options.client ?? client).get<GetAdminHomeSearchKeywordListResponses, GetAdminHomeSearchKeywordListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-search-keyword', ...options });

export const getHomePopupNotice = <ThrowOnError extends boolean = false>(options: Options<GetHomePopupNoticeData, ThrowOnError>) => (options.client ?? client).get<GetHomePopupNoticeResponses, GetHomePopupNoticeErrors, ThrowOnError>({ url: '/wello/v2/allows/home-popup-notice', ...options });

/**
 * 목록 조회
 */
export const getHomeNoticeList = <ThrowOnError extends boolean = false>(options?: Options<GetHomeNoticeListData, ThrowOnError>) => (options?.client ?? client).get<GetHomeNoticeListResponses, GetHomeNoticeListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-notice', ...options });

/**
 * 상세 조회
 */
export const getHomeNotice = <ThrowOnError extends boolean = false>(options: Options<GetHomeNoticeData, ThrowOnError>) => (options.client ?? client).get<GetHomeNoticeResponses, GetHomeNoticeErrors, ThrowOnError>({ url: '/wello/v2/allows/home-notice/{homeNoticeId}', ...options });

/**
 * 6.웰로가 추천하는 고향을 소개합니다
 *
 * @deprecated
 */
export const getHomeLoveMainRecommendedInstitutionList = <ThrowOnError extends boolean = false>(options?: Options<GetHomeLoveMainRecommendedInstitutionListData, ThrowOnError>) => (options?.client ?? client).get<GetHomeLoveMainRecommendedInstitutionListResponses, GetHomeLoveMainRecommendedInstitutionListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-love/main/recommended-institution', ...options });

/**
 * 5. 방금 기부하고 주문하신 답례품
 */
export const getRecentDonatedGiftItems = <ThrowOnError extends boolean = false>(options?: Options<GetRecentDonatedGiftItemsData, ThrowOnError>) => (options?.client ?? client).get<GetRecentDonatedGiftItemsResponses, GetRecentDonatedGiftItemsErrors, ThrowOnError>({ url: '/wello/v2/allows/home-love/main/recent-gift-products', ...options });

/**
 * 4. 주간 BEST 포토리뷰
 */
export const getWeeklyBestGiftPhotoReviews = <ThrowOnError extends boolean = false>(options?: Options<GetWeeklyBestGiftPhotoReviewsData, ThrowOnError>) => (options?.client ?? client).get<GetWeeklyBestGiftPhotoReviewsResponses, GetWeeklyBestGiftPhotoReviewsErrors, ThrowOnError>({ url: '/wello/v2/allows/home-love/main/photo-review', ...options });

/**
 * 8. 지역별 답례품
 */
export const getHomeInstitutionWithGiftProductList = <ThrowOnError extends boolean = false>(options?: Options<GetHomeInstitutionWithGiftProductListData, ThrowOnError>) => (options?.client ?? client).get<GetHomeInstitutionWithGiftProductListResponses, GetHomeInstitutionWithGiftProductListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-love/main/institution-with-gift-product', ...options });

/**
 * 2. 지역별 특산품
 */
export const getHomeLoveMainInstitutionSpecialtyList = <ThrowOnError extends boolean = false>(options?: Options<GetHomeLoveMainInstitutionSpecialtyListData, ThrowOnError>) => (options?.client ?? client).get<GetHomeLoveMainInstitutionSpecialtyListResponses, GetHomeLoveMainInstitutionSpecialtyListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-love/main/institution-specialty', ...options });

/**
 * 7. 주목할 만한 고향사업
 */
export const getHomeLoveMainFeaturedDonationBusinessesList = <ThrowOnError extends boolean = false>(options?: Options<GetHomeLoveMainFeaturedDonationBusinessesListData, ThrowOnError>) => (options?.client ?? client).get<GetHomeLoveMainFeaturedDonationBusinessesListResponses, GetHomeLoveMainFeaturedDonationBusinessesListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-love/main/featured-donation-businesses', ...options });

/**
 * 3. 오늘의 웰로 pick
 */
export const getHomeLoveMainDailyPickList = <ThrowOnError extends boolean = false>(options?: Options<GetHomeLoveMainDailyPickListData, ThrowOnError>) => (options?.client ?? client).get<GetHomeLoveMainDailyPickListResponses, GetHomeLoveMainDailyPickListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-love/main/daily-pick', ...options });

/**
 * 기부 완료 처리
 */
export const callbackComplete = <ThrowOnError extends boolean = false>(options?: Options<CallbackCompleteData, ThrowOnError>) => (options?.client ?? client).get<CallbackCompleteResponses, CallbackCompleteErrors, ThrowOnError>({ url: '/wello/v2/allows/home-love/donation/complete', ...options });

/**
 * 1:1 문의 목록 조회
 */
export const getHomeInquiryList = <ThrowOnError extends boolean = false>(options: Options<GetHomeInquiryListData, ThrowOnError>) => (options.client ?? client).get<GetHomeInquiryListResponses, GetHomeInquiryListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-inquiry', ...options });

/**
 * 1:1 문의 상세 조회
 */
export const getHomeInquiry = <ThrowOnError extends boolean = false>(options: Options<GetHomeInquiryData, ThrowOnError>) => (options.client ?? client).get<GetHomeInquiryResponses, GetHomeInquiryErrors, ThrowOnError>({ url: '/wello/v2/allows/home-inquiry/{homeInquiryId}', ...options });

/**
 * 지자체별 통계(기부자 수, 기부금액)
 */
export const getHomeDonationStatisticsList = <ThrowOnError extends boolean = false>(options?: Options<GetHomeDonationStatisticsListData, ThrowOnError>) => (options?.client ?? client).get<GetHomeDonationStatisticsListResponses, GetHomeDonationStatisticsListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-donation/statistics', ...options });

/**
 * 지정사업 기부내역 조회
 */
export const getHomeDonationHistoryByDonationBusinessList = <ThrowOnError extends boolean = false>(options: Options<GetHomeDonationHistoryByDonationBusinessListData, ThrowOnError>) => (options.client ?? client).get<GetHomeDonationHistoryByDonationBusinessListResponses, GetHomeDonationHistoryByDonationBusinessListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-donation/by-donation-business', ...options });

/**
 * 기부금 계산
 */
export const calculateDonation = <ThrowOnError extends boolean = false>(options: Options<CalculateDonationData, ThrowOnError>) => (options.client ?? client).get<CalculateDonationResponses, CalculateDonationErrors, ThrowOnError>({ url: '/wello/v2/allows/home-donation-guide/calculate', ...options });

/**
 * 이벤트 목록 조회
 */
export const getHomeDonationEvent = <ThrowOnError extends boolean = false>(options?: Options<GetHomeDonationEventData, ThrowOnError>) => (options?.client ?? client).get<GetHomeDonationEventResponses, GetHomeDonationEventErrors, ThrowOnError>({ url: '/wello/v2/allows/home-donation-event', ...options });

/**
 * 이벤트 진행 여부
 */
export const isEventInProgress = <ThrowOnError extends boolean = false>(options: Options<IsEventInProgressData, ThrowOnError>) => (options.client ?? client).get<IsEventInProgressResponses, IsEventInProgressErrors, ThrowOnError>({ url: '/wello/v2/allows/home-donation-event/is-progressing', ...options });

/**
 * 최근 포인트 지급 목록
 */
export const getRecentEventHistoryList = <ThrowOnError extends boolean = false>(options: Options<GetRecentEventHistoryListData, ThrowOnError>) => (options.client ?? client).get<GetRecentEventHistoryListResponses, GetRecentEventHistoryListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-donation-event-history/reward/recent', ...options });

/**
 * 최근 포인트 지급 목록 (9월)
 */
export const getRecentEventHistoryListInSeptember = <ThrowOnError extends boolean = false>(options: Options<GetRecentEventHistoryListInSeptemberData, ThrowOnError>) => (options.client ?? client).get<GetRecentEventHistoryListInSeptemberResponses, GetRecentEventHistoryListInSeptemberErrors, ThrowOnError>({ url: '/wello/v2/allows/home-donation-event-history/reward/recent/september', ...options });

/**
 * 초대코드로 회원 이름 조회
 */
export const getMemberNameByInviteCode = <ThrowOnError extends boolean = false>(options: Options<GetMemberNameByInviteCodeData, ThrowOnError>) => (options.client ?? client).get<GetMemberNameByInviteCodeResponses, GetMemberNameByInviteCodeErrors, ThrowOnError>({ url: '/wello/v2/allows/home-donation-event-history/member-name', ...options });

/**
 * 친구 기부 TOP 목록
 */
export const getTopDonationEventHistoryList = <ThrowOnError extends boolean = false>(options: Options<GetTopDonationEventHistoryListData, ThrowOnError>) => (options.client ?? client).get<GetTopDonationEventHistoryListResponses, GetTopDonationEventHistoryListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-donation-event-history/invitee-donation/top', ...options });

/**
 * 최근 선물상자 오픈 목록 조회
 */
export const getRecentOpenedGiftBoxList = <ThrowOnError extends boolean = false>(options?: Options<GetRecentOpenedGiftBoxListData, ThrowOnError>) => (options?.client ?? client).get<GetRecentOpenedGiftBoxListResponses, GetRecentOpenedGiftBoxListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-donation-event-gift-box/opened/recent', ...options });

/**
 * 초대 TOP 목록 조회(8월)
 */
export const getTopInviterListInAugust = <ThrowOnError extends boolean = false>(options?: Options<GetTopInviterListInAugustData, ThrowOnError>) => (options?.client ?? client).get<GetTopInviterListInAugustResponses, GetTopInviterListInAugustErrors, ThrowOnError>({ url: '/wello/v2/allows/home-donation-event-gift-box/invites/top/august-event', ...options });

/**
 * 시군구 코드로 위/경도 조회
 */
export const getNCloudGeocodingByCode = <ThrowOnError extends boolean = false>(options: Options<GetNCloudGeocodingByCodeData, ThrowOnError>) => (options.client ?? client).get<GetNCloudGeocodingByCodeResponses, GetNCloudGeocodingByCodeErrors, ThrowOnError>({ url: '/wello/v2/allows/geocoding', ...options });

/**
 * 애드팝콘 오퍼월 iOS 리워드 콜백
 *
 * IGAWorks에서 iOS 리워드 지급 시 호출되는 콜백 API
 */
export const iosCallback = <ThrowOnError extends boolean = false>(options?: Options<IosCallbackData, ThrowOnError>) => (options?.client ?? client).get<IosCallbackResponses, IosCallbackErrors, ThrowOnError>({ url: '/wello/v2/allows/external/adpopcorn-offerwall/ios/callback', ...options });

/**
 * 애드팝콘 오퍼월 Android 리워드 콜백
 *
 * IGAWorks에서 Android 리워드 지급 시 호출되는 콜백 API
 */
export const androidCallback = <ThrowOnError extends boolean = false>(options?: Options<AndroidCallbackData, ThrowOnError>) => (options?.client ?? client).get<AndroidCallbackResponses, AndroidCallbackErrors, ThrowOnError>({ url: '/wello/v2/allows/external/adpopcorn-offerwall/android/callback', ...options });

/**
 * 정부박람회 링크 url 목록 조회
 */
export const expositionLinkUrlList = <ThrowOnError extends boolean = false>(options?: Options<ExpositionLinkUrlListData, ThrowOnError>) => (options?.client ?? client).get<ExpositionLinkUrlListResponses, ExpositionLinkUrlListErrors, ThrowOnError>({ url: '/wello/v2/allows/exposition-link-url', ...options });

/**
 * 응급실 목록 조회
 */
export const getEmergencyRoomList = <ThrowOnError extends boolean = false>(options: Options<GetEmergencyRoomListData, ThrowOnError>) => (options.client ?? client).get<GetEmergencyRoomListResponses, GetEmergencyRoomListErrors, ThrowOnError>({ url: '/wello/v2/allows/emergency-room', ...options });

/**
 * 응급실 상세 조회
 */
export const getEmergencyRoom = <ThrowOnError extends boolean = false>(options: Options<GetEmergencyRoomData, ThrowOnError>) => (options.client ?? client).get<GetEmergencyRoomResponses, GetEmergencyRoomErrors, ThrowOnError>({ url: '/wello/v2/allows/emergency-room/{emergencyRoomId}', ...options });

/**
 * 응급실 실시간 데이터 조회
 */
export const getEmergencyRoomLive = <ThrowOnError extends boolean = false>(options: Options<GetEmergencyRoomLiveData, ThrowOnError>) => (options.client ?? client).get<GetEmergencyRoomLiveResponses, GetEmergencyRoomLiveErrors, ThrowOnError>({ url: '/wello/v2/allows/emergency-room/{emergencyRoomId}/live', ...options });

/**
 * 응급실 지역별 갯수 조회
 */
export const getEmergencyRoomRegionList = <ThrowOnError extends boolean = false>(options: Options<GetEmergencyRoomRegionListData, ThrowOnError>) => (options.client ?? client).get<GetEmergencyRoomRegionListResponses, GetEmergencyRoomRegionListErrors, ThrowOnError>({ url: '/wello/v2/allows/emergency-room/region', ...options });

/**
 * 응급실 목록 전체 개수 조회
 */
export const getEmergencyRoomListCount = <ThrowOnError extends boolean = false>(options: Options<GetEmergencyRoomListCountData, ThrowOnError>) => (options.client ?? client).get<GetEmergencyRoomListCountResponses, GetEmergencyRoomListCountErrors, ThrowOnError>({ url: '/wello/v2/allows/emergency-room/count', ...options });

/**
 * 응급실 관련 코드 목록 조회
 */
export const getEmergencyRoomCodeList = <ThrowOnError extends boolean = false>(options?: Options<GetEmergencyRoomCodeListData, ThrowOnError>) => (options?.client ?? client).get<GetEmergencyRoomCodeListResponses, GetEmergencyRoomCodeListErrors, ThrowOnError>({ url: '/wello/v2/allows/emergency-room/code', ...options });

/**
 * 공지사항 조회
 *
 * 공지사항을 조회합니다
 */
export const noticeList1 = <ThrowOnError extends boolean = false>(options?: Options<NoticeList1Data, ThrowOnError>) => (options?.client ?? client).get<NoticeList1Responses, NoticeList1Errors, ThrowOnError>({ url: '/wello/v2/allows/cs/notice', ...options });

/**
 * 공지사항 조회
 *
 * 공지사항을 조회합니다
 */
export const notice = <ThrowOnError extends boolean = false>(options: Options<NoticeData, ThrowOnError>) => (options.client ?? client).get<NoticeResponses, NoticeErrors, ThrowOnError>({ url: '/wello/v2/allows/cs/notice/{noticeId}', ...options });

/**
 * FAQ 목록 조회
 *
 * FAQ 목록을 조회합니다
 */
export const faqList = <ThrowOnError extends boolean = false>(options?: Options<FaqListData, ThrowOnError>) => (options?.client ?? client).get<FaqListResponses, FaqListErrors, ThrowOnError>({ url: '/wello/v2/allows/cs/faq', ...options });

/**
 * 현재 제어관리 조회
 */
export const getControlManagements = <ThrowOnError extends boolean = false>(options?: Options<GetControlManagementsData, ThrowOnError>) => (options?.client ?? client).get<GetControlManagementsResponses, GetControlManagementsErrors, ThrowOnError>({ url: '/wello/v2/allows/control-managements', ...options });

/**
 * 정책 꾸러미 목록 조회
 *
 * 정책 꾸러미 목록을 조회합니다
 */
export const situationList = <ThrowOnError extends boolean = false>(options?: Options<SituationListData, ThrowOnError>) => (options?.client ?? client).get<SituationListResponses, SituationListErrors, ThrowOnError>({ url: '/wello/v2/allows/contents/situation', ...options });

/**
 * 정책 꾸러미 정책 목록 조회
 *
 * 정책 꾸러미 정책 목록을 조회합니다
 */
export const getSituationPolicyList = <ThrowOnError extends boolean = false>(options: Options<GetSituationPolicyListData, ThrowOnError>) => (options.client ?? client).get<GetSituationPolicyListResponses, GetSituationPolicyListErrors, ThrowOnError>({ url: '/wello/v2/allows/contents/situation/{situationId}', ...options });

/**
 * 웰로 대상별 정책 - 대상 조회
 *
 * 웰로 대상별 정책 - 대상 정보를 조회합니다
 */
export const welloPickList = <ThrowOnError extends boolean = false>(options?: Options<WelloPickListData, ThrowOnError>) => (options?.client ?? client).get<WelloPickListResponses, WelloPickListErrors, ThrowOnError>({ url: '/wello/v2/allows/contents/pick', ...options });

/**
 * 웰로 대상별 정책 조회
 *
 * 웰로 대상별 정책 정보를 조회합니다
 */
export const welloPickPolicyList = <ThrowOnError extends boolean = false>(options: Options<WelloPickPolicyListData, ThrowOnError>) => (options.client ?? client).get<WelloPickPolicyListResponses, WelloPickPolicyListErrors, ThrowOnError>({ url: '/wello/v2/allows/contents/pick/{welloPickId}', ...options });

/**
 * 정책 소식 상세 조회
 */
export const getBestContents = <ThrowOnError extends boolean = false>(options: Options<GetBestContentsData, ThrowOnError>) => (options.client ?? client).get<GetBestContentsResponses, GetBestContentsErrors, ThrowOnError>({ url: '/wello/v2/allows/contents/best/{bestContentsIdIdx}', ...options });

/**
 * 정책 소식 내 고객정보 조회
 */
export const bestContentsFeedback = <ThrowOnError extends boolean = false>(options: Options<BestContentsFeedbackData, ThrowOnError>) => (options.client ?? client).get<BestContentsFeedbackResponses, BestContentsFeedbackErrors, ThrowOnError>({ url: '/wello/v2/allows/contents/best/feedback/{bestContentsId}', ...options });

/**
 * 커뮤니티 - 웰로 소식 목록 조회
 */
export const getCommunityWelloNewsList = <ThrowOnError extends boolean = false>(options: Options<GetCommunityWelloNewsListData, ThrowOnError>) => (options.client ?? client).get<GetCommunityWelloNewsListResponses, GetCommunityWelloNewsListErrors, ThrowOnError>({ url: '/wello/v2/allows/community/wello-news', ...options });

/**
 * 커뮤니티 - 웰로 소식 상세
 */
export const getCommunityWelloNews = <ThrowOnError extends boolean = false>(options: Options<GetCommunityWelloNewsData, ThrowOnError>) => (options.client ?? client).get<GetCommunityWelloNewsResponses, GetCommunityWelloNewsErrors, ThrowOnError>({ url: '/wello/v2/allows/community/wello-news/{communityIdIdx}', ...options });

/**
 * 커뮤니티 - 웰로 뉴스 피드백 (조회수, 좋아요 수, 댓글 수, 좋아요 확인 보정)
 */
export const feedbackCommunityWelloNews = <ThrowOnError extends boolean = false>(options: Options<FeedbackCommunityWelloNewsData, ThrowOnError>) => (options.client ?? client).get<FeedbackCommunityWelloNewsResponses, FeedbackCommunityWelloNewsErrors, ThrowOnError>({ url: '/wello/v2/allows/community/wello-news/feedback/{communityIdIdx}', ...options });

/**
 * API 패키지 상품 목록 조회
 */
export const getApiThemeList = <ThrowOnError extends boolean = false>(options: Options<GetApiThemeListData, ThrowOnError>) => (options.client ?? client).get<GetApiThemeListResponses, GetApiThemeListErrors, ThrowOnError>({ url: '/wello/v2/allows/api-theme', ...options });

/**
 * API 패키지 상품 조회
 */
export const getApiTheme = <ThrowOnError extends boolean = false>(options: Options<GetApiThemeData, ThrowOnError>) => (options.client ?? client).get<GetApiThemeResponses, GetApiThemeErrors, ThrowOnError>({ url: '/wello/v2/allows/api-theme/{apiThemeId}', ...options });

/**
 * API 패키지명 검색
 */
export const getApiThemeNameList = <ThrowOnError extends boolean = false>(options: Options<GetApiThemeNameListData, ThrowOnError>) => (options.client ?? client).get<GetApiThemeNameListResponses, GetApiThemeNameListErrors, ThrowOnError>({ url: '/wello/v2/allows/api-theme/name', ...options });

/**
 * API 패키지명 검색
 */
export const getApiThemeKeywordNameList = <ThrowOnError extends boolean = false>(options: Options<GetApiThemeKeywordNameListData, ThrowOnError>) => (options.client ?? client).get<GetApiThemeKeywordNameListResponses, GetApiThemeKeywordNameListErrors, ThrowOnError>({ url: '/wello/v2/allows/api-theme/keyword/name', ...options });

/**
 * API 상품명 검색
 */
export const getApiProductNameList = <ThrowOnError extends boolean = false>(options: Options<GetApiProductNameListData, ThrowOnError>) => (options.client ?? client).get<GetApiProductNameListResponses, GetApiProductNameListErrors, ThrowOnError>({ url: '/wello/v2/allows/api-product/name', ...options });

/**
 * API 개별 상품 목록 조회
 */
export const getApiPolicyList = <ThrowOnError extends boolean = false>(options: Options<GetApiPolicyListData, ThrowOnError>) => (options.client ?? client).get<GetApiPolicyListResponses, GetApiPolicyListErrors, ThrowOnError>({ url: '/wello/v2/allows/api-policy', ...options });

/**
 * API 개별 상품명 검색
 */
export const getApiPolicyNameList = <ThrowOnError extends boolean = false>(options: Options<GetApiPolicyNameListData, ThrowOnError>) => (options.client ?? client).get<GetApiPolicyNameListResponses, GetApiPolicyNameListErrors, ThrowOnError>({ url: '/wello/v2/allows/api-policy/name', ...options });

/**
 * 좋았어요 항목 타입 목록 조회
 *
 * 투어 리뷰 작성/수정 시 사용 가능한 좋았어요 항목 타입(name, desc) 목록을 조회합니다.
 */
export const findGoodPointTypes = <ThrowOnError extends boolean = false>(options?: Options<FindGoodPointTypesData, ThrowOnError>) => (options?.client ?? client).get<FindGoodPointTypesResponses, FindGoodPointTypesErrors, ThrowOnError>({ url: '/wello/v1/allows/tour/review/good-point-types', ...options });

/**
 * 분류체계 코드 목록
 *
 * rootCode / parentCode / depth 를 optional AND 필터로 적용하여 분류체계 코드 목록을 조회합니다. 페이징 없음, sort ASC 정렬.
 */
export const findTourLclsSystmCodeList = <ThrowOnError extends boolean = false>(options?: Options<FindTourLclsSystmCodeListData, ThrowOnError>) => (options?.client ?? client).get<FindTourLclsSystmCodeListResponses, FindTourLclsSystmCodeListErrors, ThrowOnError>({ url: '/wello/v1/allows/tour/lcls-systm-code', ...options });

/**
 * 축제 상세
 *
 * 축제 ID 로 상세 정보를 조회한다. 이미지, 반복정보, 프로그램, 테마 목록을 포함한다.
 */
export const findTourFestival = <ThrowOnError extends boolean = false>(options: Options<FindTourFestivalData, ThrowOnError>) => (options.client ?? client).get<FindTourFestivalResponses, FindTourFestivalErrors, ThrowOnError>({ url: '/wello/v1/allows/tour/festival/{tourId}', ...options });

/**
 * 축제 리뷰 목록 조회
 *
 * 공개(deleteYN=false AND displayYN=true) 리뷰만 createAt DESC로 페이지 반환
 */
export const findTourReviews = <ThrowOnError extends boolean = false>(options: Options<FindTourReviewsData, ThrowOnError>) => (options.client ?? client).get<FindTourReviewsResponses, FindTourReviewsErrors, ThrowOnError>({ url: '/wello/v1/allows/tour/festival/{tourId}/review', ...options });

/**
 * 아티클 상세
 *
 * 아티클 상세 정보와 매핑된 테마 목록을 조회한다.
 */
export const findArticle = <ThrowOnError extends boolean = false>(options: Options<FindArticleData, ThrowOnError>) => (options.client ?? client).get<FindArticleResponses, FindArticleErrors, ThrowOnError>({ url: '/wello/v1/allows/tour/article/{articleId}', ...options });

/**
 * 투어 조회수/스크랩 정보 조회 (비로그인 허용)
 *
 * 아티클 의 조회수 정보를 조회한다.
 */
export const findArticleFeedback = <ThrowOnError extends boolean = false>(options: Options<FindArticleFeedbackData, ThrowOnError>) => (options.client ?? client).get<FindArticleFeedbackResponses, FindArticleFeedbackErrors, ThrowOnError>({ url: '/wello/v1/allows/tour/article/{articleId}/feedback', ...options });

/**
 * 테마별 축제 목록
 *
 * 선택된 테마에 매핑된 TourFestival 카드 목록. subRegionCode 좌표 기준 거리(distance, 미터)를 포함하며, 진행중→예정→미정→종료 순 + 현재 월에 걸치는 축제 우선 + 거리 ASC로 정렬한다. status enum 포함 (페이지네이션).
 */
export const findThemeFestivals = <ThrowOnError extends boolean = false>(options: Options<FindThemeFestivalsData, ThrowOnError>) => (options.client ?? client).get<FindThemeFestivalsResponses, FindThemeFestivalsErrors, ThrowOnError>({ url: '/wello/v1/allows/theme/{themeId}/festival', ...options });

/**
 * 테마별 Article 목록
 *
 * 선택된 테마에 매핑된 Article 카드 목록 (페이지네이션).
 */
export const findThemeArticles = <ThrowOnError extends boolean = false>(options: Options<FindThemeArticlesData, ThrowOnError>) => (options.client ?? client).get<FindThemeArticlesResponses, FindThemeArticlesErrors, ThrowOnError>({ url: '/wello/v1/allows/theme/{themeId}/article', ...options });

/**
 * 월별 테마 큐레이션 조회
 *
 * 전달받은 날짜의 월에 해당하는 테마 목록과 이전달/다음달 테마 존재 여부를 반환한다.
 */
export const findMonthlyThemes = <ThrowOnError extends boolean = false>(options: Options<FindMonthlyThemesData, ThrowOnError>) => (options.client ?? client).get<FindMonthlyThemesResponses, FindMonthlyThemesErrors, ThrowOnError>({ url: '/wello/v1/allows/theme/monthly', ...options });

/**
 * 회원 탈퇴(관리자용)
 */
export const resignMember = <ThrowOnError extends boolean = false>(options: Options<ResignMemberData, ThrowOnError>) => (options.client ?? client).delete<ResignMemberResponses, ResignMemberErrors, ThrowOnError>({
    url: '/wello/v2/allows/member',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * KB PAY 회원 탈회
 */
export const resignWelloWithKbPay = <ThrowOnError extends boolean = false>(options: Options<ResignWelloWithKbPayData, ThrowOnError>) => (options.client ?? client).delete<ResignWelloWithKbPayResponses, ResignWelloWithKbPayErrors, ThrowOnError>({
    url: '/wello/v2/allows/kb-pay',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
